// this file is generated by update_shopify_store_data.py at 2026-09-29 21:12:07.021277
var courses = [
    {
        "course_id": "AD00E14D-C3A1-EF11-9994-005056A740BF",
        "course_version": 2,
        "name": "Bigger Brains: Microsoft Essentials Bundle",
        "course_type": 32,
        "author_information": "",
        "description": "Enhance your skills and gain the confidence you need to be more productive with the most powerful desktop applications in the world! Bigger Brains\u2019 Microsoft Essentials courses cover Microsoft Excel, Outlook, PowerPoint, and Word. Up to 20 courses are available for these versions: Office 2016, 2019, 2021, and 365.",
        "learning_objectives_html": "At the conclusion, participants should be able to:",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "F7C5141E-E710-F111-99A6-005056A7DAD4",
                "course_category_name": "Bigger Brains (Curricula)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C504515B-A376-EF11-9990-005056A70840",
                "course_category_name": "Bigger Brains",
                "is_system_course_category": null
            },
            {
                "course_category_id": "BE641706-AAA2-EF11-9995-005056A725AD",
                "course_category_name": "Bigger Brains - Microsoft Essentials Bundle - Curricula",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": null,
            "accreditation_statement": null,
            "course_level_accreditation_statement": null,
            "credit_display_name": null,
            "credit_units": null,
            "credit_unit_display_name": null
        },
        "sub_courses": [
            {
                "course_id": "23C13D8A-438A-EF11-9992-005056A70B00",
                "course_version": 2,
                "name": "Mastering Excel 2019 - Advanced",
                "course_type": 1,
                "author_information": "Bigger Brains",
                "description": "There are two kinds of people: Those who are masters at Excel2019 or Excel 365, and those who wish they were\r\n\r\nWhen you master Excel 2019 or Excel 365, you have one of the most practical and valuable skillsets in modern business. A spreadsheet guru can work wonders\u2014from organizing lists; to creating multi-layered, interactive reports; to answering critical business questions like ROI, budget allocations, expense tracking, and more. This course builds on your existing Excel knowledge and teaches you how to use links, Lookup functions, Data Validation, Macros, data tables, and more.\r\n\r\nEnjoy award winning HD content in the \u201cUniquely Engaging\u201dTM Bigger Brains Teacher-Learner style! Taught by top subject matter experts, Bigger Brains courses are professionally designed around key learning objectives, and include captions and transcripts in 29 languages, and downloadable handouts.",
                "learning_objectives_html": "<p><strong>You will be able to:</strong></p>\r\n<ul>\r\n    <li>Use multiple worksheets and workbooks to track, retrieve, consolidate and report on data using cell links, Group Mode, 3D Reference formulas, and Consolidate</li>\r\n    <li>Collaborate with others using Comments, Track Changes, Sharing, Co-Authoring, and Compare and Merge</li>\r\n    <li>Prepare a document for sharing by checking for accessibility and sensitive information and adding a digital signature</li>\r\n    <li>Protect your worksheets and workbooks from changes</li>\r\n    <li>Keep your data consistent and accurate with Data Validation and automate tasks with Macros</li>\r\n    <li>Perform complex calculations by developing a deep understanding of Excel&rsquo;s VLOOKUP, MATCH, and INDEX functions</li>\r\n    <li>Quickly find and address errors in your formulas with Tracing, Evaluate Formula, and the Watch Window, as well as add error handling with the IFNA and IFERROR functions</li>\r\n    <li>Use your data to plan and forecast trends and explore a variety of outcomes based on variables and scenarios</li>\r\n    <li>Visualize geographic data with Map Charts and 3D Map Tours</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "5FD53AE4-2326-E711-9EDE-005056B14F90",
                        "course_category_name": "Workplace Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8BECCD1B-AAA2-EF11-9995-005056A725AD",
                        "course_category_name": "Bigger Brains - Business Technology Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F5470F5D-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C504515B-A376-EF11-9990-005056A70840",
                        "course_category_name": "Bigger Brains",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6E6072D9-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Business Technology Bundle \u2013 Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9E064EE7-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle \u2013 Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "46FE47C6-0C11-E811-BA0F-005056B11FFF",
                        "course_category_name": "Module",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BC68CAB2-AD48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Business Technology Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "69EA49AC-A9A2-EF11-9995-005056A725AD",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AC120620-CD8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Fire Safety",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "4C7DF442-448A-EF11-9992-005056A70B00",
                "course_version": 4,
                "name": "Mastering Excel 365 - Advanced (2025)",
                "course_type": 1,
                "author_information": "Bigger Brains",
                "description": "Learn many of Excel\u2019s advanced tools for analyzing and reporting on your data\u00a0\r\n\r\nBeing able to use Microsoft Excel skillfully is crucial for all business professionals who use, analyze, and apply data. Excel is the most popular data analysis tool in the workplace, so increasing your understanding of its advanced features is both necessary and smart.\u00a0\r\n\r\nExcel expert Kathy Jones will show you how to make use of advanced features to summarize information, identify errors, apply conditional formatting, and find and assess information. She will also demonstrate how to best utilize available filtering and sorting techniques, including the new dynamic array functions.\u00a0 Learning to use these techniques will enable you to find information you need when analyzing either large or small data sets.\u00a0\u00a0\r\n\r\nSince graphs greatly enhance your reports, you\u2019ll learn how to add trendlines to charts to add a visual element to your forecasting and how to save time by creating custom templates that can be used repeatedly. You\u2019ll also be able to create and modify important objects such as PivotTables, macros, and graphics.\u00a0\r\n\r\nFinally, if you\u2019re looking to easily identify rankings or need to generate random numbers for inspections, this course will teach you how to use Excel to help you do it!\u00a0\r\n\r\nEnjoy award winning HD content in the \u201cUniquely Engaging\u201dTM Bigger Brains Teacher-Learner style! Taught by top subject matter experts, Bigger Brains courses are professionally designed around key learning objectives, and include captions and transcripts in 29 languages, and downloadable handouts.",
                "learning_objectives_html": "<p><strong>You will be able to:</strong></p>\r\n<ul>\r\n    <li>Create, save, and use a custom worksheet template&nbsp;</li>\r\n    <li>Explore dynamic array functions</li>\r\n    <li>Use the LOOKUP, text, date, and database functions</li>\r\n    <li>Use advanced filtering and sorting techniques</li>\r\n    <li>Apply and modify data validation for numbers, text, and date cells</li>\r\n    <li>Use Subtotal functions and the Subtotals feature&nbsp;</li>\r\n    <li>Use Data Consolidation to summarize data from multiple ranges</li>\r\n    <li>Create, modify, and filter a PivotTable</li>\r\n    <li>Create macros and add form controls</li>\r\n    <li>Create custom charts and chart templates</li>\r\n    <li>Insert, format, and modify graphics, screenshots, symbols, and 3D models</li>\r\n    <li>Run the Accessibility Checker and address needed changes</li>\r\n    <li>Protect sheets, workbooks, and ranges</li>\r\n</ul>",
                "course_outline_html": "Learn many of Excel&rsquo;s tools for analyzing and reporting on your data.&nbsp;",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "8BECCD1B-AAA2-EF11-9995-005056A725AD",
                        "course_category_name": "Bigger Brains - Business Technology Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5FD53AE4-2326-E711-9EDE-005056B14F90",
                        "course_category_name": "Workplace Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C504515B-A376-EF11-9990-005056A70840",
                        "course_category_name": "Bigger Brains",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6E6072D9-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Business Technology Bundle \u2013 Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9E064EE7-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle \u2013 Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F5470F5D-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "46FE47C6-0C11-E811-BA0F-005056B11FFF",
                        "course_category_name": "Module",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "69EA49AC-A9A2-EF11-9995-005056A725AD",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BC68CAB2-AD48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Business Technology Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AC120620-CD8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Fire Safety",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "PMI",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This course is approved by the Project Management Institute (PMI) and qualifies for Professional Development Units (PDUs).",
                    "credit_display_name": "PMI",
                    "credit_units": 4.25,
                    "credit_unit_display_name": "PDU"
                },
                "sub_courses": []
            },
            {
                "course_id": "3D7F5274-468A-EF11-9992-005056A70B00",
                "course_version": 2,
                "name": "Mastering Outlook 2019 - Basics",
                "course_type": 1,
                "author_information": "Bigger Brains",
                "description": "From time waster to productivity booster: change the way you use Microsoft Outlook\r\n\r\nFew things have a greater impact on your productivity than the way you employ Outlook. Too many people waste time on unnecessary tasks that could be managed automatically or handled in a fraction of the time. Use this Outlook course to make the leap from being a mere user to being an Outlook master\r\n\r\nEnjoy award winning HD content in the \u201cUniquely Engaging\u201dTM Bigger Brains Teacher-Learner style! Taught by top subject matter experts, Bigger Brains courses are professionally designed around key learning objectives, and include captions and transcripts in 29 languages, and downloadable handouts.",
                "learning_objectives_html": "<p><strong>You will be able to:</strong></p>\r\n<ul>\r\n    <li>Navigate the Outlook interface</li>\r\n    <li>Send, reply to, forward, and print emails&nbsp;</li>\r\n    <li>Send and receive attachments</li>\r\n    <li>Access Help options including searching for articles and training videos, contacting support, and locating important features</li>\r\n    <li>Format email content using text formats, pictures, illustrations, Styles, and Themes</li>\r\n    <li>Customize your view options</li>\r\n    <li>Organize messages using categories, flags, and folders</li>\r\n    <li>Create appointments, events, and meetings</li>\r\n    <li>Manage multiple calendars</li>\r\n    <li>Manage your contact lists and tasks</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "8BECCD1B-AAA2-EF11-9995-005056A725AD",
                        "course_category_name": "Bigger Brains - Business Technology Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5FD53AE4-2326-E711-9EDE-005056B14F90",
                        "course_category_name": "Workplace Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6E6072D9-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Business Technology Bundle \u2013 Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C504515B-A376-EF11-9990-005056A70840",
                        "course_category_name": "Bigger Brains",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F5470F5D-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9E064EE7-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle \u2013 Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "46FE47C6-0C11-E811-BA0F-005056B11FFF",
                        "course_category_name": "Module",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AC120620-CD8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Fire Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "69EA49AC-A9A2-EF11-9995-005056A725AD",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BC68CAB2-AD48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Business Technology Bundle - Courses",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "1FDFC907-488A-EF11-9992-005056A70B00",
                "course_version": 2,
                "name": "Mastering PowerPoint 2021 - Beginner",
                "course_type": 1,
                "author_information": "Bigger Brains",
                "description": "Don\u2019t settle for lackluster presentations. Learn the basics of creating interesting presentations using the features in PowerPoint 2021.\u00a0\r\n\r\nMicrosoft PowerPoint is the most common tool used for presentations in the workplace, so using it effectively is a crucial skill for any business professional. Whether you\u2019re designing a presentation for a meeting or creating a handout, you\u2019ll learn the basics of organizing and effectively presenting the information you need to share. In this Bigger Brains course our PowerPoint expert, Kathy Snizaski, walks you through all the basic features of Microsoft PowerPoint so you can start creating your own presentations.\u00a0\u00a0\u00a0\r\n\r\nEnjoy award winning HD content in the \u201cUniquely Engaging\u201dTM Bigger Brains Teacher-Learner style! Taught by top subject matter experts, Bigger Brains courses are professionally designed around key learning objectives, and include captions and transcripts in 29 languages, and downloadable handouts.",
                "learning_objectives_html": "<p><strong>You will be able to:</strong></p>\r\n<ul>\r\n    <li>View and navigate a presentation</li>\r\n    <li>Create a new presentation</li>\r\n    <li>Add and format text</li>\r\n    <li>Insert and modify pictures and shapes</li>\r\n    <li>Insert a table</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "BC68CAB2-AD48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Business Technology Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AC120620-CD8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Fire Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "69EA49AC-A9A2-EF11-9995-005056A725AD",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "46FE47C6-0C11-E811-BA0F-005056B11FFF",
                        "course_category_name": "Module",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9E064EE7-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle \u2013 Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F5470F5D-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C504515B-A376-EF11-9990-005056A70840",
                        "course_category_name": "Bigger Brains",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6E6072D9-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Business Technology Bundle \u2013 Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5FD53AE4-2326-E711-9EDE-005056B14F90",
                        "course_category_name": "Workplace Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8BECCD1B-AAA2-EF11-9995-005056A725AD",
                        "course_category_name": "Bigger Brains - Business Technology Bundle - Courses",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "PMI",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This course is approved by the Project Management Institute (PMI) and qualifies for Professional Development Units (PDUs).",
                    "credit_display_name": "PMI",
                    "credit_units": 0.5,
                    "credit_unit_display_name": "PDU"
                },
                "sub_courses": []
            },
            {
                "course_id": "DF54F18B-488A-EF11-9992-005056A70B00",
                "course_version": 3,
                "name": "Mastering PowerPoint 365 - Beginner (2025)",
                "course_type": 1,
                "author_information": "Bigger Brains",
                "description": "Don\u2019t settle for lackluster presentations. Learn the basics of creating interesting presentations using the features in PowerPoint 365.\r\n\r\nMicrosoft PowerPoint is the most common tool used for presentations in the workplace, so using it effectively is a crucial skill for any business professional. Whether you\u2019re designing a presentation for a meeting or creating a handout, you\u2019ll learn the basics of organizing and effectively presenting the information you need to share. In this Bigger Brains course our PowerPoint guru, Kathy Snizaski, walks you through all the basic features of Microsoft PowerPoint so you can start creating your own presentations.\u00a0\u00a0\r\n\r\nEnjoy award winning HD content in the \u201cUniquely Engaging\u201dTM Bigger Brains Teacher-Learner style! Taught by top subject matter experts, Bigger Brains courses are professionally designed around key learning objectives, and include captions and transcripts in 29 languages, and downloadable handouts.",
                "learning_objectives_html": "<p><strong> You will be able to:</strong></p>\r\n<ul>\r\n    <li>View and navigate a presentation</li>\r\n    <li>Create a new presentation</li>\r\n    <li>Add and format text</li>\r\n    <li>Insert and modify pictures and shapes</li>\r\n    <li>Insert a table</li>\r\n</ul>",
                "course_outline_html": "Learn the basics of creating presentations that will cause people to sit up and pay attention.&nbsp;",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "5FD53AE4-2326-E711-9EDE-005056B14F90",
                        "course_category_name": "Workplace Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8BECCD1B-AAA2-EF11-9995-005056A725AD",
                        "course_category_name": "Bigger Brains - Business Technology Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9E064EE7-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle \u2013 Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6E6072D9-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Business Technology Bundle \u2013 Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C504515B-A376-EF11-9990-005056A70840",
                        "course_category_name": "Bigger Brains",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F5470F5D-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "46FE47C6-0C11-E811-BA0F-005056B11FFF",
                        "course_category_name": "Module",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "69EA49AC-A9A2-EF11-9995-005056A725AD",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BC68CAB2-AD48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Business Technology Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AC120620-CD8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Fire Safety",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "PMI",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This course is approved by the Project Management Institute (PMI) and qualifies for Professional Development Units (PDUs).",
                    "credit_display_name": "PMI",
                    "credit_units": 0.5,
                    "credit_unit_display_name": "PDU"
                },
                "sub_courses": []
            },
            {
                "course_id": "A620E8DB-498A-EF11-9992-005056A70B00",
                "course_version": 2,
                "name": "Mastering Word 2019 - Advanced",
                "course_type": 1,
                "author_information": "Bigger Brains",
                "description": "Learn the powerful advanced skills of Microsoft Word 2019 or Word 365\u2014delivered in easily searchable, highly informative content lessons\r\n\r\nMicrosoft Word is hands-down the most powerful document creation tool on the planet. While used by millions of people each day, there are very few who know how to use Microsoft Word properly. In this comprehensive course produced by Microsoft Certified Trainer, Barbara Evers, we\u2019ll help you build on intermediate skills in Word 2019 or Word 365 to create more professional and effective documents\r\n\r\nEnjoy award winning HD content in the \u201cUniquely Engaging\u201dTM Bigger Brains Teacher-Learner style! Taught by top subject matter experts, Bigger Brains courses are professionally designed around key learning objectives, and include captions and transcripts in 29 languages, and downloadable handouts.",
                "learning_objectives_html": "<p><strong>You will be able to:</strong></p>\r\n<ul>\r\n    <li>Manipulate images and apply Image Effects and Styles</li>\r\n    <li>Add custom graphicswith text boxes, WordArt, and SmartArt</li>\r\n    <li>Collaborate using Track Changes and the Compare and Combine feature</li>\r\n    <li>Add references including captions, hyperlinks, and footnotes</li>\r\n    <li>Secure a document by restricting changes, adding password protection, and includingdigital signatures</li>\r\n    <li>Add and edit content controls</li>\r\n    <li>Automate tasks using Macros</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "5FD53AE4-2326-E711-9EDE-005056B14F90",
                        "course_category_name": "Workplace Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8BECCD1B-AAA2-EF11-9995-005056A725AD",
                        "course_category_name": "Bigger Brains - Business Technology Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6E6072D9-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Business Technology Bundle \u2013 Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C504515B-A376-EF11-9990-005056A70840",
                        "course_category_name": "Bigger Brains",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F5470F5D-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9E064EE7-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle \u2013 Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "46FE47C6-0C11-E811-BA0F-005056B11FFF",
                        "course_category_name": "Module",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AC120620-CD8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Fire Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "69EA49AC-A9A2-EF11-9995-005056A725AD",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BC68CAB2-AD48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Business Technology Bundle - Courses",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "569126E3-438A-EF11-9992-005056A70B00",
                "course_version": 2,
                "name": "Mastering Excel 2021 - Basics",
                "course_type": 1,
                "author_information": "Bigger Brains",
                "description": "Go beyond the basics of data entry to analyze your data and create visually appealing workbooks.\u00a0\r\n\r\nMicrosoft Excel is the most popular data analysis tool in the workplace, so using it effectively is a crucial skill for any business professional. In this course you\u2019ll learn to make your spreadsheets easily readable and visually appealing, while including complex functions and summary reports.\u00a0 Excel expert Kathy Jones will also show you how to address function errors, customize your charts, and create and use tables and PivotTables to easily manipulate and summarize your data.\u00a0\r\n\r\nEnjoy award winning HD content in the \u201cUniquely Engaging\u201dTM Bigger Brains Teacher-Learner style! Taught by top subject matter experts, Bigger Brains courses are professionally designed around key learning objectives, and include captions and transcripts in 29 languages, and downloadable handouts.",
                "learning_objectives_html": "<p><strong>You will be able to:</strong></p>\r\n<ul>\r\n    <li>Open and save existing workbooks</li>\r\n    <li>Manage rows, columns, and worksheets</li>\r\n    <li>Create and use named ranges</li>\r\n    <li>Add logical and conditional functions</li>\r\n    <li>Address formula errors</li>\r\n    <li>Apply cell and number formats, including cell styles and themes</li>\r\n    <li>Modify charts</li>\r\n    <li>Create Tables and PivotTables</li>\r\n    <li>Configure page settings and headers/footers for printing</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "69EA49AC-A9A2-EF11-9995-005056A725AD",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AC120620-CD8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Fire Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BC68CAB2-AD48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Business Technology Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "46FE47C6-0C11-E811-BA0F-005056B11FFF",
                        "course_category_name": "Module",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F5470F5D-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9E064EE7-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle \u2013 Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C504515B-A376-EF11-9990-005056A70840",
                        "course_category_name": "Bigger Brains",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6E6072D9-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Business Technology Bundle \u2013 Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5FD53AE4-2326-E711-9EDE-005056B14F90",
                        "course_category_name": "Workplace Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8BECCD1B-AAA2-EF11-9995-005056A725AD",
                        "course_category_name": "Bigger Brains - Business Technology Bundle - Courses",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "PMI",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This course is approved by the Project Management Institute (PMI) and qualifies for Professional Development Units (PDUs).",
                    "credit_display_name": "PMI",
                    "credit_units": 2.75,
                    "credit_unit_display_name": "PDU"
                },
                "sub_courses": []
            },
            {
                "course_id": "10A5B68F-478A-EF11-9992-005056A70B00",
                "course_version": 2,
                "name": "Mastering PowerPoint 2019",
                "course_type": 1,
                "author_information": "Bigger Brains",
                "description": "Learn about PowerPoint 2019 or PowerPoint 365\u2014Delivered in easily searchable, highly informative lessons.\r\n\r\nHave you seen someone deliver a PowerPoint presentation that was well done? Do you remember the difference it made\u2014not only in helping you understand the content but the way it made you feel about the presenter? This course will show you how to turn lackluster presentations into something that is visually stimulating and works to keep your audience engaged. In this Bigger Brains course our PowerPoint guru, Kelly Vandever, walks you through all the features of Microsoft PowerPoint 2019\r\n\r\nEnjoy award winning HD content in the \u201cUniquely Engaging\u201dTM Bigger Brains Teacher-Learner style! Taught by top subject matter experts, Bigger Brains courses are professionally designed around key learning objectives, and include captions and transcripts in 29 languages, and downloadable handouts.",
                "learning_objectives_html": "<p><strong>You will be able to:</strong></p>\r\n<ul>\r\n    <li>View and navigate the PowerPoint interface</li>\r\n    <li>Group, arrange, and animate objects</li>\r\n    <li>Add and modify tables, charts, pictures, and shapes</li>\r\n    <li>Insert advanced graphics like SmartArt, 3D models, SVGs, and Icons</li>\r\n    <li>Apply transitions and animations</li>\r\n    <li>Customize the interface and update options</li>\r\n    <li>Modify Slide Masters, Notes Masters, and Handout Masters</li>\r\n    <li>Add media to your presentation (audio and video)</li>\r\n    <li>Collaborate with others using Share, Comments, Compare Merge, and Forms</li>\r\n    <li>Record and distribute your presentations</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "AC120620-CD8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Fire Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BC68CAB2-AD48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Business Technology Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "69EA49AC-A9A2-EF11-9995-005056A725AD",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "46FE47C6-0C11-E811-BA0F-005056B11FFF",
                        "course_category_name": "Module",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9E064EE7-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle \u2013 Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6E6072D9-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Business Technology Bundle \u2013 Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C504515B-A376-EF11-9990-005056A70840",
                        "course_category_name": "Bigger Brains",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F5470F5D-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5FD53AE4-2326-E711-9EDE-005056B14F90",
                        "course_category_name": "Workplace Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8BECCD1B-AAA2-EF11-9995-005056A725AD",
                        "course_category_name": "Bigger Brains - Business Technology Bundle - Courses",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "A46FF8A8-478A-EF11-9992-005056A70B00",
                "course_version": 2,
                "name": "Mastering PowerPoint 2019 - Advanced",
                "course_type": 1,
                "author_information": "Bigger Brains",
                "description": "Learn advanced features to get the most out of PowerPoint 2019 or PowerPoint 365\r\n\r\nHave you seen someone deliver a PowerPoint presentation that was well done? Do you remember the difference it made\u2014not only in helping you understand the content but the way it made you feel about the presenter? This course will show you how to turn lackluster presentations into something that is visually stimulating and works to keep your audience engaged\r\n\r\nEnjoy award winning HD content in the \u201cUniquely Engaging\u201dTM Bigger Brains Teacher-Learner style! Taught by top subject matter experts, Bigger Brains courses are professionally designed around key learning objectives, and include captions and transcripts in 29 languages, and downloadable handouts.",
                "learning_objectives_html": "<p><strong>You will be able to:</strong></p>\r\n<ul>\r\n    <li>Customize the PowerPoint interface</li>\r\n    <li>Set Windows and PowerPoint options</li>\r\n    <li>Modify Slide Masters, Notes Masters, and Handout Masters</li>\r\n    <li>Insert advanced graphics like SmartArt, 3D models, SVGs, and icons</li>\r\n    <li>Add audio and video to your presentation</li>\r\n    <li>Add advanced Animations and Transitions including Slide Timing</li>\r\n    <li>Collaborate with others using Share, Comments, Compare Merge, and Forms</li>\r\n    <li>Customize your slide show with Captions and Subtitles, Translation, Dictation, and Hyperlinks</li>\r\n    <li>Record and distribute your presentations</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "8BECCD1B-AAA2-EF11-9995-005056A725AD",
                        "course_category_name": "Bigger Brains - Business Technology Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5FD53AE4-2326-E711-9EDE-005056B14F90",
                        "course_category_name": "Workplace Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6E6072D9-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Business Technology Bundle \u2013 Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C504515B-A376-EF11-9990-005056A70840",
                        "course_category_name": "Bigger Brains",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F5470F5D-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9E064EE7-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle \u2013 Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "46FE47C6-0C11-E811-BA0F-005056B11FFF",
                        "course_category_name": "Module",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "69EA49AC-A9A2-EF11-9995-005056A725AD",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BC68CAB2-AD48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Business Technology Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AC120620-CD8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Fire Safety",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "3E5D92CA-488A-EF11-9992-005056A70B00",
                "course_version": 3,
                "name": "Mastering PowerPoint 365 - Intermediate (2025)",
                "course_type": 1,
                "author_information": "Bigger Brains",
                "description": "Learn how to create visually interesting presentations that will cause people to sit up and pay attention.\u00a0\r\n\r\nMicrosoft PowerPoint is the most popular tool for presentations in the workplace, so using it effectively is a crucial skill for any business professional. In this course, you\u2019ll learn design principles and how to customize themes to help you capture and retain the attention of your audience. Our PowerPoint expert Kathy Snizaski will also show you how to make your slides more readable using formatting tools and customizing tabs and spacing. Do you need to illustrate data? You can create a chart right in PowerPoint or import data from Excel and graph it on a slide.\u00a0\u00a0\r\n\r\nPictures and other graphics are always important in a presentation, and you\u2019ll learn how to customize and animate many types of graphics, including SmartArt, text boxes, and shapes. And if you need to collaborate, you\u2019ll learn how to use comments effectively to exchange ideas about the presentation. You\u2019ll be amazed at all the tools available to create and customize interesting and informative presentations.\u00a0\r\n\r\nEnjoy award winning HD content in the \u201cUniquely Engaging\u201dTM Bigger Brains Teacher-Learner style! Taught by top subject matter experts, Bigger Brains courses are professionally designed around key learning objectives, and include captions and transcripts in 29 languages, and downloadable handouts.",
                "learning_objectives_html": "<p><strong>You will be able to:</strong></p>\r\n<ul>\r\n    <li>Modify slide design and apply themes</li>\r\n    <li>Use editing tools</li>\r\n    <li>Add and modify tabs, line spacing, and paragraph spacing</li>\r\n    <li>Insert and modify charts</li>\r\n    <li>Customize SmartArt, pictures, shapes, and text boxes</li>\r\n    <li>Create a photo album</li>\r\n    <li>Apply and customize animation and transitions</li>\r\n    <li>Use comments</li>\r\n    <li>Print a presentation and create handouts</li>\r\n</ul>",
                "course_outline_html": "Learn how to create visually interesting presentations that will cause people to sit up and pay attention.&nbsp;",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "AC120620-CD8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Fire Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BC68CAB2-AD48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Business Technology Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "69EA49AC-A9A2-EF11-9995-005056A725AD",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "46FE47C6-0C11-E811-BA0F-005056B11FFF",
                        "course_category_name": "Module",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F5470F5D-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9E064EE7-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle \u2013 Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C504515B-A376-EF11-9990-005056A70840",
                        "course_category_name": "Bigger Brains",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6E6072D9-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Business Technology Bundle \u2013 Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8BECCD1B-AAA2-EF11-9995-005056A725AD",
                        "course_category_name": "Bigger Brains - Business Technology Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5FD53AE4-2326-E711-9EDE-005056B14F90",
                        "course_category_name": "Workplace Safety",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "PMI",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This course is approved by the Project Management Institute (PMI) and qualifies for Professional Development Units (PDUs).",
                    "credit_display_name": "PMI",
                    "credit_units": 2.0,
                    "credit_unit_display_name": "PDU"
                },
                "sub_courses": []
            },
            {
                "course_id": "CF0176F9-498A-EF11-9992-005056A70B00",
                "course_version": 2,
                "name": "Mastering Word 2019 - Basics",
                "course_type": 1,
                "author_information": "Bigger Brains",
                "description": "Learn the basics of Microsoft Word 2019or Word 365\u2014delivered in easily searchable, highly informative content lessons\r\n\r\nMicrosoft Word is hands-down the most powerful document creation tool on the planet. Word is more than a word processor. It has the potential to make you more productive and make your job easier! While used by millions of people each day, there are very few who know how to use Microsoft Word\u2019sfunctions and tools properly. In this basics course produced by Microsoft Certified Trainer, BarbaraEvers, we\u2019ll show you everything you need to know to start harnessing the power of Microsoft Word\r\n\r\nEnjoy award winning HD content in the \u201cUniquely Engaging\u201dTM Bigger Brains Teacher-Learner style! Taught by top subject matter experts, Bigger Brains courses are professionally designed around key learning objectives, and include captions and transcripts in 29 languages, and downloadable handouts.",
                "learning_objectives_html": "<p><strong>You will be able to:</strong></p>\r\n<ul>\r\n    <li>Navigate the Word interface</li>\r\n    <li>Create and save documents</li>\r\n    <li>Select, copy, and move text</li>\r\n    <li>Preview and print documents</li>\r\n    <li>View multiple documents and customize your version of Word</li>\r\n    <li>Format documents using character formatting, paragraph layout, spacing, and alignment</li>\r\n    <li>Work efficiently using Find and Replace, Repetitive Formatting, and Styles</li>\r\n    <li>Create and format lists and tables</li>\r\n    <li>Insert images and symbols</li>\r\n    <li>Control page appearance using Page Layout options such as page breaks, headers, and footers</li>\r\n    <li>Check spelling and readability</li>\r\n    <li>Use research tools and Accessibility Checker</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "BC68CAB2-AD48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Business Technology Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AC120620-CD8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Fire Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "69EA49AC-A9A2-EF11-9995-005056A725AD",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "46FE47C6-0C11-E811-BA0F-005056B11FFF",
                        "course_category_name": "Module",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9E064EE7-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle \u2013 Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F5470F5D-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C504515B-A376-EF11-9990-005056A70840",
                        "course_category_name": "Bigger Brains",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6E6072D9-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Business Technology Bundle \u2013 Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5FD53AE4-2326-E711-9EDE-005056B14F90",
                        "course_category_name": "Workplace Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8BECCD1B-AAA2-EF11-9995-005056A725AD",
                        "course_category_name": "Bigger Brains - Business Technology Bundle - Courses",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "D2B09E78-4A8A-EF11-9992-005056A70B00",
                "course_version": 3,
                "name": "Mastering Word 365 - Beginner (2025)",
                "course_type": 1,
                "author_information": "Bigger Brains",
                "description": "Learn the basics of the world\u2019s most powerful document creation software\u00a0\u00a0\r\n\r\nWord is more than a word processor. It has the potential to make you more productive and make your job easier! While used by millions of people daily, there are few who know how to maximize Word\u2019s functions and features. In this basics course taught by Microsoft trainer Christina Tankersley, we\u2019ll show you everything you need to know to start harnessing the full power of Microsoft Word.\u00a0\r\n\r\nEnjoy award winning HD content in the \u201cUniquely Engaging\u201dTM Bigger Brains Teacher-Learner style! Taught by top subject matter experts, Bigger Brains courses are professionally designed around key learning objectives, and include captions and transcripts in 29 languages, and downloadable handouts.",
                "learning_objectives_html": "<p><strong>You will be able to:</strong></p>\r\n<ul>\r\n    <li>Navigate the Word interface</li>\r\n    <li>Navigate within documents</li>\r\n    <li>Create and save documents</li>\r\n    <li>Get Help</li>\r\n    <li>Select, copy, and move text</li>\r\n    <li>Format text</li>\r\n    <li>Use bullets and numbered lists</li>\r\n    <li>Insert pictures and shapes</li>\r\n    <li>Insert a table</li>\r\n</ul>",
                "course_outline_html": "Learn the basics of the world&rsquo;s most powerful document creation software",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "AC120620-CD8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Fire Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "69EA49AC-A9A2-EF11-9995-005056A725AD",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BC68CAB2-AD48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Business Technology Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "46FE47C6-0C11-E811-BA0F-005056B11FFF",
                        "course_category_name": "Module",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C504515B-A376-EF11-9990-005056A70840",
                        "course_category_name": "Bigger Brains",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6E6072D9-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Business Technology Bundle \u2013 Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9E064EE7-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle \u2013 Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F5470F5D-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5FD53AE4-2326-E711-9EDE-005056B14F90",
                        "course_category_name": "Workplace Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8BECCD1B-AAA2-EF11-9995-005056A725AD",
                        "course_category_name": "Bigger Brains - Business Technology Bundle - Courses",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "PMI",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This course is approved by the Project Management Institute (PMI) and qualifies for Professional Development Units (PDUs).",
                    "credit_display_name": "PMI",
                    "credit_units": 0.75,
                    "credit_unit_display_name": "PDU"
                },
                "sub_courses": []
            },
            {
                "course_id": "834E29B4-4A8A-EF11-9992-005056A70B00",
                "course_version": 3,
                "name": "Mastering Word 365 - Intermediate (2025)",
                "course_type": 1,
                "author_information": "Bigger Brains",
                "description": "Learn important features of the world\u2019s most powerful document-creation software\u00a0\u00a0\r\n\r\nMicrosoft Word is a powerful word processing and document creation software used by business professionals worldwide.\u00a0 This intermediate course is taught by Microsoft trainer Christina Tankersley, who will show you how to skillfully use key functions and features. You\u2019ll also learn how to manage your documents and how to improve them using editing and collaboration tools.\u00a0\r\n\r\nEnjoy award winning HD content in the \u201cUniquely Engaging\u201dTM Bigger Brains Teacher-Learner style! Taught by top subject matter experts, Bigger Brains courses are professionally designed around key learning objectives, and include captions and transcripts in 29 languages, and downloadable handouts.",
                "learning_objectives_html": "<p><strong>You will be able to:</strong></p>\r\n<ul>\r\n    <li>Arrange, view, and manage multiple windows</li>\r\n    <li>Use advanced Find and Replace options and Paste Special options</li>\r\n    <li>Customize AutoCorrect</li>\r\n    <li>Create lists from existing text and modify multi-level lists</li>\r\n    <li>Add, modify, and delete tabs</li>\r\n    <li>Apply text effects, add borders and shading to text, and change page borders</li>\r\n    <li>Change margins and customize line breaks and paragraph options</li>\r\n    <li>Insert page numbers, headers, and footers and apply them to specific pages</li>\r\n    <li>Insert and modify footnotes and endnotes</li>\r\n    <li>Add calculations to a table and format, split, and merge table cells</li>\r\n    <li>Collaborate using tracking and comments</li>\r\n    <li>Create Word Art and insert SmartArt and 3D models</li>\r\n    <li>Create tables of tables, tables of figures, and tables of contents</li>\r\n</ul>",
                "course_outline_html": "Learn to utilize key features of the world&rsquo;s most powerful document creation software.",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "BC68CAB2-AD48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Business Technology Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "69EA49AC-A9A2-EF11-9995-005056A725AD",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AC120620-CD8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Fire Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "46FE47C6-0C11-E811-BA0F-005056B11FFF",
                        "course_category_name": "Module",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F5470F5D-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9E064EE7-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle \u2013 Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C504515B-A376-EF11-9990-005056A70840",
                        "course_category_name": "Bigger Brains",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6E6072D9-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Business Technology Bundle \u2013 Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5FD53AE4-2326-E711-9EDE-005056B14F90",
                        "course_category_name": "Workplace Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8BECCD1B-AAA2-EF11-9995-005056A725AD",
                        "course_category_name": "Bigger Brains - Business Technology Bundle - Courses",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "PMI",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This course is approved by the Project Management Institute (PMI) and qualifies for Professional Development Units (PDUs).",
                    "credit_display_name": "PMI",
                    "credit_units": 1.75,
                    "credit_unit_display_name": "PDU"
                },
                "sub_courses": []
            },
            {
                "course_id": "19EE74A5-438A-EF11-9992-005056A70B00",
                "course_version": 2,
                "name": "Mastering Excel 2019 - Basics",
                "course_type": 1,
                "author_information": "Bigger Brains",
                "description": "There are two kinds of people: Those who are masters at Excel2019 or Excel 365, and those who wish they were\r\n\r\nWhen you master Excel 2019 or Excel 365, you have one of the most practical and valuable skillsets in modern business. A spreadsheet guru can work wonders\u2014from organizing lists; to creating multi-layered, interactive reports; to answering critical business questions like ROI, budget allocations, expense tracking, and more. This course is your first step towards becoming an expert at using Excel 2019\r\n\r\nEnjoy award winning HD content in the \u201cUniquely Engaging\u201dTM Bigger Brains Teacher-Learner style! Taught by top subject matter experts, Bigger Brains courses are professionally designed around key learning objectives, and include captions and transcripts in 29 languages, and downloadable handouts.",
                "learning_objectives_html": "<p><strong>You will be able to:</strong></p>\r\n<ul>\r\n    <li>Navigate the interface including creating and saving workbooks, quickly accessing commands, and selecting and entering data</li>\r\n    <li>Perform calculations using formulas and functions</li>\r\n    <li>Insert and delete rows and columns</li>\r\n    <li>Apply formatting to text, numbers, and cells including using Cell Styles and Conditional Formatting</li>\r\n    <li>Control how your worksheets print using Page Layout options, Page Breaks, and Headers and Footers</li>\r\n    <li>Manage multiple worksheets within a workbook including adding, removing, renaming, reordering, copying, and color-coding worksheets</li>\r\n    <li>Use View features to compare workbooks, compare worksheets, or save Custom Views</li>\r\n    <li>Customize Excel by adding Groups to the Ribbon and modifying the Quick Access Toolbar</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "69EA49AC-A9A2-EF11-9995-005056A725AD",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BC68CAB2-AD48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Business Technology Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AC120620-CD8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Fire Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "46FE47C6-0C11-E811-BA0F-005056B11FFF",
                        "course_category_name": "Module",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9E064EE7-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle \u2013 Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C504515B-A376-EF11-9990-005056A70840",
                        "course_category_name": "Bigger Brains",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6E6072D9-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Business Technology Bundle \u2013 Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F5470F5D-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5FD53AE4-2326-E711-9EDE-005056B14F90",
                        "course_category_name": "Workplace Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8BECCD1B-AAA2-EF11-9995-005056A725AD",
                        "course_category_name": "Bigger Brains - Business Technology Bundle - Courses",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "A4970BC4-438A-EF11-9992-005056A70B00",
                "course_version": 2,
                "name": "Mastering Excel 2019 - Intermediate",
                "course_type": 1,
                "author_information": "Bigger Brains",
                "description": "There are two kinds of people: Those who are masters at Excel2019 or Excel 365, and those who wish they were\r\n\r\nWhen you master Excel 2019 or Excel 365, you have one of the most practical and valuable skillsets in modern business. A spreadsheet guru can work wonders\u2014from organizing lists; to creating multi-layered, interactive reports; to answering critical business questions like ROI, budget allocations, expense tracking, and more. This course builds on your existingExcelknowledge and teaches you how to manage data, charts, and tables, and how to use powerful tools such as PivotTables, PivotCharts, Slicers, Timelines, and more\r\n\r\nEnjoy award winning HD content in the \u201cUniquely Engaging\u201dTM Bigger Brains Teacher-Learner style! Taught by top subject matter experts, Bigger Brains courses are professionally designed around key learning objectives, and include captions and transcripts in 29 languages, and downloadable handouts.",
                "learning_objectives_html": "<p><strong>You will be able to:</strong></p>\r\n<ul>\r\n    <li>Create and use named ranges</li>\r\n    <li>Insert functions into spreadsheets includingDate and Time functions, Logical functions, Text functions, Math functions,Database functions, Subtotals, and nested functions</li>\r\n    <li>Sort and filter data</li>\r\n    <li>Create and modify tables</li>\r\n    <li>Apply advanced Conditional Formatting</li>\r\n    <li>Create and modify charts and graphics, and apply advanced charting tools</li>\r\n    <li>Create a PivotTable</li>\r\n    <li>Use advanced PivotTable tools, create a PivotChart, and filter data using Slicers andTimelines</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "5FD53AE4-2326-E711-9EDE-005056B14F90",
                        "course_category_name": "Workplace Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8BECCD1B-AAA2-EF11-9995-005056A725AD",
                        "course_category_name": "Bigger Brains - Business Technology Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F5470F5D-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6E6072D9-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Business Technology Bundle \u2013 Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C504515B-A376-EF11-9990-005056A70840",
                        "course_category_name": "Bigger Brains",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9E064EE7-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle \u2013 Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "46FE47C6-0C11-E811-BA0F-005056B11FFF",
                        "course_category_name": "Module",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AC120620-CD8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Fire Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BC68CAB2-AD48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Business Technology Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "69EA49AC-A9A2-EF11-9995-005056A725AD",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle - Courses",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "44BC3020-448A-EF11-9992-005056A70B00",
                "course_version": 2,
                "name": "Mastering Excel 2021 \u2013 Intermediate",
                "course_type": 1,
                "author_information": "Bigger Brains",
                "description": "Learn many of Excel\u2019s tools for analyzing and sharing your data\u00a0\r\n\r\nMicrosoft Excel is the most popular data analysis tool in the workplace, so using it effectively is a crucial skill for any business professional. In this course you\u2019ll learn great tools to modify your data and refine your workbook.\u00a0 Excel expert Kathy Jones will also show you how to nest functions and modify and format charts. You\u2019ll even learn to enhance your visualizations by adding sparklines, pictures, and SmartArt. And if you need to work with others, you\u2019ll learn some great tools available when sharing your workbooks, including comments, hyperlinks, track changes, and share options.\u00a0\r\n\r\nEnjoy award winning HD content in the \u201cUniquely Engaging\u201dTM Bigger Brains Teacher-Learner style! Taught by top subject matter experts, Bigger Brains courses are professionally designed around key learning objectives, and include captions and transcripts in 29 languages, and downloadable handouts.",
                "learning_objectives_html": "<p><strong>You will be able to:</strong></p>\r\n<ul>\r\n    <li>Use Flash Fill, Text to Columns, and Group Mode to work with your data</li>\r\n    <li>Use editing features such as Find and Replace, proofing options, and research tools to refine your workbook</li>\r\n    <li>Modify workbook views</li>\r\n    <li>Apply conditional formatting to text, numbers, and dates</li>\r\n    <li>Apply custom number formatting</li>\r\n    <li>Use nested, logical, and statistical functions</li>\r\n    <li>Modify and format charts</li>\r\n    <li>Add sparklines, pictures, and SmartArt</li>\r\n    <li>Modify Tables, PivotTables, and web queries</li>\r\n    <li>Share workbooks</li>\r\n    <li>Use tools to enhance sharing such as hyperlinks, track changes, and comments</li>\r\n    <li>Analyze data with Goal Seek and Data Tables</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "BC68CAB2-AD48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Business Technology Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "69EA49AC-A9A2-EF11-9995-005056A725AD",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AC120620-CD8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Fire Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "46FE47C6-0C11-E811-BA0F-005056B11FFF",
                        "course_category_name": "Module",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6E6072D9-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Business Technology Bundle \u2013 Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C504515B-A376-EF11-9990-005056A70840",
                        "course_category_name": "Bigger Brains",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F5470F5D-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9E064EE7-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle \u2013 Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5FD53AE4-2326-E711-9EDE-005056B14F90",
                        "course_category_name": "Workplace Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8BECCD1B-AAA2-EF11-9995-005056A725AD",
                        "course_category_name": "Bigger Brains - Business Technology Bundle - Courses",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "PMI",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This course is approved by the Project Management Institute (PMI) and qualifies for Professional Development Units (PDUs).",
                    "credit_display_name": "PMI",
                    "credit_units": 3.25,
                    "credit_unit_display_name": "PDU"
                },
                "sub_courses": []
            },
            {
                "course_id": "1EDBE962-448A-EF11-9992-005056A70B00",
                "course_version": 3,
                "name": "Mastering Excel 365 - Basics (2025)",
                "course_type": 1,
                "author_information": "Bigger Brains",
                "description": "Go beyond the basics of data entry to analyze your data and create visually appealing workbooks.\r\n\r\nMicrosoft Excel is the most popular data analysis tool in the workplace, so using it effectively is a crucial skill for any business professional. In this course you\u2019ll learn to make your spreadsheets easily readable and visually appealing, while including complex functions and summary reports. \u00a0Excel expert Kathy Jones will also show you how to address function errors, customize your charts, and create and use tables and PivotTables to easily manipulate and summarize your data.\r\n\r\nEnjoy award winning HD content in the \u201cUniquely Engaging\u201dTM Bigger Brains Teacher-Learner style! Taught by top subject matter experts, Bigger Brains courses are professionally designed around key learning objectives, and include captions and transcripts in 29 languages, and downloadable handouts.",
                "learning_objectives_html": "<p><strong>You will be able to:</strong></p>\r\n<ul>\r\n    <li>Open and save existing workbooks</li>\r\n    <li>Manage rows, columns, and worksheets</li>\r\n    <li>Create and use named ranges</li>\r\n    <li>Add logical and conditional functions</li>\r\n    <li>Address formula errors</li>\r\n    <li>Apply cell and number formats, including cell styles and themes</li>\r\n    <li>Modify charts</li>\r\n    <li>Create Tables and PivotTables</li>\r\n    <li>Configure page settings and headers/footers for printing</li>\r\n</ul>",
                "course_outline_html": "Go beyond the basics of data entry to analyze your data and create visually appealing workbooks.&nbsp;",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "69EA49AC-A9A2-EF11-9995-005056A725AD",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AC120620-CD8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Fire Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BC68CAB2-AD48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Business Technology Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "46FE47C6-0C11-E811-BA0F-005056B11FFF",
                        "course_category_name": "Module",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9E064EE7-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle \u2013 Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6E6072D9-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Business Technology Bundle \u2013 Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C504515B-A376-EF11-9990-005056A70840",
                        "course_category_name": "Bigger Brains",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F5470F5D-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8BECCD1B-AAA2-EF11-9995-005056A725AD",
                        "course_category_name": "Bigger Brains - Business Technology Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5FD53AE4-2326-E711-9EDE-005056B14F90",
                        "course_category_name": "Workplace Safety",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "PMI",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This course is approved by the Project Management Institute (PMI) and qualifies for Professional Development Units (PDUs).",
                    "credit_display_name": "PMI",
                    "credit_units": 2.75,
                    "credit_unit_display_name": "PDU"
                },
                "sub_courses": []
            },
            {
                "course_id": "1FFBB8C0-448A-EF11-9992-005056A70B00",
                "course_version": 3,
                "name": "Mastering Excel 365 - Intermediate (2025)",
                "course_type": 1,
                "author_information": "Bigger Brains",
                "description": "Learn many of Excel\u2019s tools for analyzing and sharing your data.\r\n\r\nMicrosoft Excel is the most popular data analysis tool in the workplace, so using it effectively is a crucial skill for any business professional. In this course you\u2019ll learn great tools to modify your data and refine your workbook.\u00a0 Excel expert Kathy Jones will also show you how to nest functions and modify and format charts. You\u2019ll even learn to enhance your visualizations by adding sparklines, pictures, and SmartArt. And if you need to work with others, you\u2019ll learn some great tools available when sharing your workbooks, including comments, hyperlinks, track changes, and share options.\r\n\r\nEnjoy award winning HD content in the \u201cUniquely Engaging\u201dTM Bigger Brains Teacher-Learner style! Taught by top subject matter experts, Bigger Brains courses are professionally designed around key learning objectives, and include captions and transcripts in 29 languages, and downloadable handouts.",
                "learning_objectives_html": "<p><strong>You will be able to:</strong></p>\r\n<ul>\r\n    <li>Use Flash Fill, Text to Columns, and Group Mode to work with your data</li>\r\n    <li>Use editing features such as Find and Replace, proofing options, and research tools to refine your workbook</li>\r\n    <li>Modify workbook views</li>\r\n    <li>Apply conditional formatting to text, numbers, and dates</li>\r\n    <li>Apply custom number formatting</li>\r\n    <li>Use nested, logical, and statistical functions</li>\r\n    <li>Modify and format charts</li>\r\n    <li>Add sparklines, pictures, and SmartArt</li>\r\n    <li>Modify Tables, PivotTables, and web queries</li>\r\n    <li>Share workbooks</li>\r\n    <li>Use tools to enhance sharing such as hyperlinks, track changes, and comments</li>\r\n    <li>Analyze data with Goal Seek and Data Tables</li>\r\n</ul>",
                "course_outline_html": "Learn many of Excel&rsquo;s tools for analyzing and sharing your data.&nbsp;",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "BC68CAB2-AD48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Business Technology Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "69EA49AC-A9A2-EF11-9995-005056A725AD",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AC120620-CD8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Fire Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "46FE47C6-0C11-E811-BA0F-005056B11FFF",
                        "course_category_name": "Module",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C504515B-A376-EF11-9990-005056A70840",
                        "course_category_name": "Bigger Brains",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F5470F5D-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9E064EE7-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle \u2013 Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6E6072D9-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Business Technology Bundle \u2013 Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8BECCD1B-AAA2-EF11-9995-005056A725AD",
                        "course_category_name": "Bigger Brains - Business Technology Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5FD53AE4-2326-E711-9EDE-005056B14F90",
                        "course_category_name": "Workplace Safety",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "PMI",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This course is approved by the Project Management Institute (PMI) and qualifies for Professional Development Units (PDUs).",
                    "credit_display_name": "PMI",
                    "credit_units": 3.25,
                    "credit_unit_display_name": "PDU"
                },
                "sub_courses": []
            },
            {
                "course_id": "10F02D38-468A-EF11-9992-005056A70B00",
                "course_version": 2,
                "name": "Mastering Outlook 2019",
                "course_type": 1,
                "author_information": "Bigger Brains",
                "description": "From time waster to productivity booster: change the way you use Microsoft Outlook\r\n\r\nFew things have a greater impact on your productivity than the way you employ Outlook. Too many people waste time on unnecessary tasks that could be managed automatically or handled in a fraction of the time. Use this Outlook course to make the leap from being a mere user to being an Outlook master\r\n\r\nEnjoy award winning HD content in the \u201cUniquely Engaging\u201dTM Bigger Brains Teacher-Learner style! Taught by top subject matter experts, Bigger Brains courses are professionally designed around key learning objectives, and include captions and transcripts in 29 languages, and downloadable handouts.",
                "learning_objectives_html": "<p><strong>You will be able to:</strong></p>\r\n<ul>\r\n    <li>Navigate the Outlook interface</li>\r\n    <li>Send, reply to, forward, and print emails&nbsp;</li>\r\n    <li>Send and receive attachments</li>\r\n    <li>Access Help options</li>\r\n    <li>Format email content using text formats, pictures, illustrations, Styles, and Themes</li>\r\n    <li>Organize messages using categories, flags, and folders</li>\r\n    <li>Create appointments, events, and meetings</li>\r\n    <li>Manage multiple calendars</li>\r\n    <li>Manage your contact lists and tasks</li>\r\n    <li>Modify message properties to set importance or adjust delivery options&nbsp;</li>\r\n    <li>Customize Outlook to work for your preferences</li>\r\n    <li>Create custom views and Search Folders</li>\r\n    <li>Automate message management with Automatic Replies, Message Rules, and Quick Steps</li>\r\n    <li>Delegate folder access</li>\r\n    <li>Collaborate with others by sharing your Contacts or Calendars&nbsp;</li>\r\n    <li>Describe difference between Auto-Archive and Online Archive</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "5FD53AE4-2326-E711-9EDE-005056B14F90",
                        "course_category_name": "Workplace Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8BECCD1B-AAA2-EF11-9995-005056A725AD",
                        "course_category_name": "Bigger Brains - Business Technology Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F5470F5D-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6E6072D9-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Business Technology Bundle \u2013 Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9E064EE7-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle \u2013 Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C504515B-A376-EF11-9990-005056A70840",
                        "course_category_name": "Bigger Brains",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "46FE47C6-0C11-E811-BA0F-005056B11FFF",
                        "course_category_name": "Module",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AC120620-CD8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Fire Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "69EA49AC-A9A2-EF11-9995-005056A725AD",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BC68CAB2-AD48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Business Technology Bundle - Courses",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "A60AF352-468A-EF11-9992-005056A70B00",
                "course_version": 2,
                "name": "Mastering Outlook 2019 - Advanced",
                "course_type": 1,
                "author_information": "Bigger Brains",
                "description": "From time waster to productivity booster: change the way you use Microsoft outlook\r\n\r\nFew things have a greater impact on your productivity than the way you employ Outlook. Too many people waste time on unnecessary tasks that could be managed automatically or handled in a fraction of the time. Use this Outlook course to make the leap from being a mere user to being an Outlook master\"\r\n\r\nEnjoy award winning HD content in the \u201cUniquely Engaging\u201dTM Bigger Brains Teacher-Learner style! Taught by top subject matter experts, Bigger Brains courses are professionally designed around key learning objectives, and include captions and transcripts in 29 languages, and downloadable handouts.",
                "learning_objectives_html": "<p><strong> You will be able to:</strong></p>\r\n<ul>\r\n    <li>Modify message properties to set importance or adjust delivery options&nbsp;</li>\r\n    <li>Customize Outlook to work for your preferences</li>\r\n    <li>Create custom views and Search Folders</li>\r\n    <li>Automate message management with Automatic Replies, Message Rules, and Quick Steps</li>\r\n    <li>Manage multiple calendars</li>\r\n    <li>Manage your contacts and activities as Tasks</li>\r\n    <li>Delegate folder access</li>\r\n    <li>Collaborate with others by sharing your Contacts or Calendars&nbsp;</li>\r\n    <li>Describe the difference between Auto-Archive and Online Archive</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "69EA49AC-A9A2-EF11-9995-005056A725AD",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BC68CAB2-AD48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Business Technology Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AC120620-CD8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Fire Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "46FE47C6-0C11-E811-BA0F-005056B11FFF",
                        "course_category_name": "Module",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9E064EE7-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle \u2013 Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C504515B-A376-EF11-9990-005056A70840",
                        "course_category_name": "Bigger Brains",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6E6072D9-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Business Technology Bundle \u2013 Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F5470F5D-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5FD53AE4-2326-E711-9EDE-005056B14F90",
                        "course_category_name": "Workplace Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8BECCD1B-AAA2-EF11-9995-005056A725AD",
                        "course_category_name": "Bigger Brains - Business Technology Bundle - Courses",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "5D79D2C8-478A-EF11-9992-005056A70B00",
                "course_version": 2,
                "name": "Mastering PowerPoint 2019 - Basics",
                "course_type": 1,
                "author_information": "Bigger Brains",
                "description": "Learn the basics ofPowerPoint2019or PowerPoint 365\u2014Delivered in easily searchable, highly informative lessons\r\n\r\nUsing PowerPoint effectively is a crucial skill for any business professional. Whetheryou\u2019redesigning a presentation for a meeting, creating a handout, or even creating and exporting a custom video, PowerPoint 2019and PowerPoint 365 are tools that everyone should feel comfortable using. In this Bigger Brains course our PowerPoint guru, Kelly Vandever, walks you through all the basic features of Microsoft PowerPoint 2019.\r\n\r\nEnjoy award winning HD content in the \u201cUniquely Engaging\u201dTM Bigger Brains Teacher-Learner style! Taught by top subject matter experts, Bigger Brains courses are professionally designed around key learning objectives, and include captions and transcripts in 29 languages, and downloadable handouts.",
                "learning_objectives_html": "<p><strong>You will be able to:</strong></p>\r\n<ul>\r\n    <li>View and navigate a presentation</li>\r\n    <li>Add and format slides, text, and lists</li>\r\n    <li>Insert and modify pictures and shapes</li>\r\n    <li>Group, arrange, and animate objects</li>\r\n    <li>Insert tables and charts</li>\r\n    <li>Apply transitions</li>\r\n    <li>Deliver and distribute a presentation</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "AC120620-CD8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Fire Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BC68CAB2-AD48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Business Technology Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "69EA49AC-A9A2-EF11-9995-005056A725AD",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "46FE47C6-0C11-E811-BA0F-005056B11FFF",
                        "course_category_name": "Module",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F5470F5D-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6E6072D9-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Business Technology Bundle \u2013 Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C504515B-A376-EF11-9990-005056A70840",
                        "course_category_name": "Bigger Brains",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9E064EE7-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle \u2013 Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5FD53AE4-2326-E711-9EDE-005056B14F90",
                        "course_category_name": "Workplace Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8BECCD1B-AAA2-EF11-9995-005056A725AD",
                        "course_category_name": "Bigger Brains - Business Technology Bundle - Courses",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "36655DEC-478A-EF11-9992-005056A70B00",
                "course_version": 2,
                "name": "Mastering PowerPoint 2021 - Basics",
                "course_type": 1,
                "author_information": "Bigger Brains",
                "description": "Learn how to create visually interesting presentations that will cause people to sit up and pay attention.\u00a0\r\n\r\nMicrosoft PowerPoint is the most popular tool for presentations in the workplace, so using it effectively is a crucial skill for any business professional. In this course you\u2019ll learn to modify your bulleted and numbered lists, add tables for readability, and add animation to keep viewers engaged. Whether you are using a template design, customizing your own text boxes, or adding dynamic pictures, our PowerPoint expert Kathy Snizaski will show you how to create and customize interesting presentations, and present them flawlessly.\u00a0\u00a0\r\n\r\nEnjoy award winning HD content in the \u201cUniquely Engaging\u201dTM Bigger Brains Teacher-Learner style! Taught by top subject matter experts, Bigger Brains courses are professionally designed around key learning objectives, and include captions and transcripts in 29 languages, and downloadable handouts.",
                "learning_objectives_html": "<p><strong>You will be able to:</strong></p>\r\n<ul>\r\n    <li>Create a new presentation from a template</li>\r\n    <li>Open and save existing presentations</li>\r\n    <li>Modify slide design</li>\r\n    <li>Format text, text boxes, and lists</li>\r\n    <li>Spell check the document</li>\r\n    <li>Insert and modify pictures and shapes</li>\r\n    <li>Insert and modify a table</li>\r\n    <li>Add transitions and animation</li>\r\n    <li>Present a slide show</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "8BECCD1B-AAA2-EF11-9995-005056A725AD",
                        "course_category_name": "Bigger Brains - Business Technology Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5FD53AE4-2326-E711-9EDE-005056B14F90",
                        "course_category_name": "Workplace Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F5470F5D-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6E6072D9-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Business Technology Bundle \u2013 Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C504515B-A376-EF11-9990-005056A70840",
                        "course_category_name": "Bigger Brains",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9E064EE7-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle \u2013 Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "46FE47C6-0C11-E811-BA0F-005056B11FFF",
                        "course_category_name": "Module",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AC120620-CD8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Fire Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BC68CAB2-AD48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Business Technology Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "69EA49AC-A9A2-EF11-9995-005056A725AD",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle - Courses",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "PMI",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This course is approved by the Project Management Institute (PMI) and qualifies for Professional Development Units (PDUs).",
                    "credit_display_name": "PMI",
                    "credit_units": 1.75,
                    "credit_unit_display_name": "PDU"
                },
                "sub_courses": []
            },
            {
                "course_id": "C683B549-488A-EF11-9992-005056A70B00",
                "course_version": 3,
                "name": "Mastering PowerPoint 365 - Advanced (2025)",
                "course_type": 1,
                "author_information": "Bigger Brains",
                "description": "Learn how to create visually interesting presentations that will cause people to sit up and pay attention.\u00a0\r\n\r\nMicrosoft PowerPoint is the most popular tool for presentations in the workplace, so using it effectively is a crucial skill for any business professional. In this course, our PowerPoint expert Kathy Snizaski will show you how to use PowerPoint\u2019s advanced customization options and editing tools to create powerful and dynamic presentations.\u00a0\u00a0\r\n\u00a0\r\nEngaging, interesting, and clear presentations are effective. Kathy will show you how to use WordArt and advanced graphics tools and how to insert audio and video files to make a presentation engaging for your audience. You\u2019ll also learn to share data in a clear and compelling way using custom tables and charts.\u00a0 In addition, you\u2019ll learn how to use custom animations and transitions to enhance your delivery.\r\n\r\nEnjoy award winning HD content in the \u201cUniquely Engaging\u201dTM Bigger Brains Teacher-Learner style! Taught by top subject matter experts, Bigger Brains courses are professionally designed around key learning objectives, and include captions and transcripts in 29 languages, and downloadable handouts.",
                "learning_objectives_html": "<p><strong>You will be able to:</strong></p>\r\n<ul>\r\n    <li>Insert tabs and groups on the ribbon</li>\r\n    <li>Access and restore earlier versions of a PowerPoint file</li>\r\n    <li>Use Advanced Editing and Translation tools</li>\r\n    <li>Create and modify WordArt</li>\r\n    <li>Format Shapes, pictures, and 3D Models using effects and other advanced options</li>\r\n    <li>Insert, modify, and format tables and charts</li>\r\n    <li>Embed a linked Excel workbook and update links</li>\r\n    <li>Add and modify animations, including 3D models and custom motion path animation</li>\r\n    <li>Use the animation pane to identify existing animation and reorder animations</li>\r\n    <li>Insert video files from stock videos, YouTube, and your computer</li>\r\n    <li>Record narration and add bookmarks to audio and video clips</li>\r\n    <li>Use the Slide Master to format slide titles and modify bullets</li>\r\n    <li>Save theme formatting and apply it to a new presentation</li>\r\n    <li>Set slide transition duration and advancement timings</li>\r\n</ul>",
                "course_outline_html": "Learn how to create visually interesting presentations that will cause people to sit up and pay attention.&nbsp;",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "BC68CAB2-AD48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Business Technology Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "69EA49AC-A9A2-EF11-9995-005056A725AD",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AC120620-CD8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Fire Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "46FE47C6-0C11-E811-BA0F-005056B11FFF",
                        "course_category_name": "Module",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9E064EE7-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle \u2013 Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F5470F5D-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C504515B-A376-EF11-9990-005056A70840",
                        "course_category_name": "Bigger Brains",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6E6072D9-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Business Technology Bundle \u2013 Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8BECCD1B-AAA2-EF11-9995-005056A725AD",
                        "course_category_name": "Bigger Brains - Business Technology Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5FD53AE4-2326-E711-9EDE-005056B14F90",
                        "course_category_name": "Workplace Safety",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "PMI",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This course is approved by the Project Management Institute (PMI) and qualifies for Professional Development Units (PDUs).",
                    "credit_display_name": "PMI",
                    "credit_units": 1.75,
                    "credit_unit_display_name": "PDU"
                },
                "sub_courses": []
            },
            {
                "course_id": "11F44819-4A8A-EF11-9992-005056A70B00",
                "course_version": 2,
                "name": "Mastering Word 2019 - Intermediate",
                "course_type": 1,
                "author_information": "Bigger Brains",
                "description": "Learn intermediate skills of Microsoft Word 2019 or Word 365\u2014delivered in easily searchable, highly informative content lessons\r\n\r\nMicrosoft Word is hands-down the most powerful document creation tool on the planet. While used by millions of people each day, there are very few who know how to use Microsoft Word properly. In this comprehensive course produced by Microsoft Certified Trainer, Barbara Evers, we\u2019ll help you build on basic skills in Word 2019 or Word 365 to create more professional and effective documents\r\n\r\nEnjoy award winning HD content in the \u201cUniquely Engaging\u201dTM Bigger Brains Teacher-Learner style! Taught by top subject matter experts, Bigger Brains courses are professionally designed around key learning objectives, and include captions and transcripts in 29 languages, and downloadable handouts.",
                "learning_objectives_html": "<p><strong>You will be able to:</strong></p>\r\n<ul>\r\n    <li>Sort table data, perform calculations, and create charts</li>\r\n    <li>Create Text and Table Styles</li>\r\n    <li>Apply document Themes</li>\r\n    <li>Insert reusable content (building blocks) from the Quick Parts menu</li>\r\n    <li>Use built-in templates and create custom templates</li>\r\n    <li>Control paragraph flow with paragraph options, section breaks, and columns</li>\r\n    <li>Manage long documents using an Index, Table of Contents, Table of Figures, and Table of Authorities</li>\r\n    <li>Organize long documents with an Outline or Master Document</li>\r\n    <li>Use Mail Merge to create mass mailings or mass emails</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "5FD53AE4-2326-E711-9EDE-005056B14F90",
                        "course_category_name": "Workplace Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8BECCD1B-AAA2-EF11-9995-005056A725AD",
                        "course_category_name": "Bigger Brains - Business Technology Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F5470F5D-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C504515B-A376-EF11-9990-005056A70840",
                        "course_category_name": "Bigger Brains",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9E064EE7-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle \u2013 Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6E6072D9-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Business Technology Bundle \u2013 Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "46FE47C6-0C11-E811-BA0F-005056B11FFF",
                        "course_category_name": "Module",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AC120620-CD8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Fire Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BC68CAB2-AD48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Business Technology Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "69EA49AC-A9A2-EF11-9995-005056A725AD",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle - Courses",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "BB469F35-4A8A-EF11-9992-005056A70B00",
                "course_version": 3,
                "name": "Mastering Word 365 - Advanced (2025)",
                "course_type": 1,
                "author_information": "Bigger Brains",
                "description": "Learn advanced skills using Microsoft\u2019s word processing software\u2014delivered in easy-to-follow, highly informative lessons.\u00a0\r\n\r\nIn this comprehensive course taught by Microsoft Certified Trainer Christina Tankersley, you\u2019ll build on your Word skillset so you can create advanced documents that will impress all your colleagues and save you time. You\u2019ll learn how to streamline your document creation by using Outline mode to structure text, by creating and modifying AutoText, by customizing and saving your themes, and by creating and running macros.\u00a0\r\n\r\nChristina will help you polish your documents by showing you how to split text into columns, change the grammar and spell check settings in Editor, use advanced cropping features. and manage SmartArt. You\u2019ll also learn how to enhance your document graphics by using picture correction and artistic effects on images and by inserting online videos\u00a0and Excel tables.\u00a0\u00a0\r\n\r\nIf you work with global partners, you\u2019ll need to know how to use the built-in translation features. And if you\u2019re working with large documents, you\u2019ll want to learn how to enhance navigation with bookmarks, hyperlinks, cross-references, and a Table of Contents.\r\n\r\nEnjoy award winning HD content in the \u201cUniquely Engaging\u201dTM Bigger Brains Teacher-Learner style! Taught by top subject matter experts, Bigger Brains courses are professionally designed around key learning objectives, and include captions and transcripts in 29 languages, and downloadable handouts.",
                "learning_objectives_html": "<p><strong>You will be able to:</strong></p>\r\n<ul>\r\n    <li>Use backstage features to find metadata, set file options, and set permissions for shared documents&nbsp;</li>\r\n    <li>Use Outline mode to manage document text</li>\r\n    <li>Create and modify AutoText</li>\r\n    <li>Customize and save themes</li>\r\n    <li>Split text into columns</li>\r\n    <li>Change grammar and spell check settings in Editor</li>\r\n    <li>Use advanced cropping and manage SmartArt</li>\r\n    <li>Modify grouping and text wrapping options</li>\r\n    <li>Perform picture correction and apply artistic effects on images</li>\r\n    <li>Insert online videos\u202fand Excel tables</li>\r\n    <li>Perform calculations in a table</li>\r\n    <li>Use translation options</li>\r\n    <li>Add Tables of Contents, Bibliographies, bookmarks, and hyperlinks</li>\r\n    <li>Create, run, and edit macros</li>\r\n</ul>",
                "course_outline_html": "Maximize your ability to utilize advanced features of the world&rsquo;s most powerful document creation software.",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "AC120620-CD8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Fire Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "69EA49AC-A9A2-EF11-9995-005056A725AD",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BC68CAB2-AD48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Business Technology Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "46FE47C6-0C11-E811-BA0F-005056B11FFF",
                        "course_category_name": "Module",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F5470F5D-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6E6072D9-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Business Technology Bundle \u2013 Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9E064EE7-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle \u2013 Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C504515B-A376-EF11-9990-005056A70840",
                        "course_category_name": "Bigger Brains",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5FD53AE4-2326-E711-9EDE-005056B14F90",
                        "course_category_name": "Workplace Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8BECCD1B-AAA2-EF11-9995-005056A725AD",
                        "course_category_name": "Bigger Brains - Business Technology Bundle - Courses",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "PMI",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This course is approved by the Project Management Institute (PMI) and qualifies for Professional Development Units (PDUs).",
                    "credit_display_name": "PMI",
                    "credit_units": 1.5,
                    "credit_unit_display_name": "PDU"
                },
                "sub_courses": []
            },
            {
                "course_id": "3B48DF97-4A8A-EF11-9992-005056A70B00",
                "course_version": 3,
                "name": "Mastering Word 365 - Expert (2025)",
                "course_type": 1,
                "author_information": "Bigger Brains",
                "description": "Learn to expertly utilize Microsoft Word\u2019s advanced features for efficiency, consistency, and collaboration.  \r\n\r\nIn this comprehensive course taught by Microsoft Certified Trainer Christina Tankersley, you\u2019ll learn how to use all the expert features in Word 365. You\u2019ll learn how to customize the Word interface to save time. You\u2019ll learn to customize tables of contents, watermarks, footnotes, headers, footers, and columns and see how to work with custom and exclude dictionaries. You\u2019ll also streamline mailings by learning how to set up, customize, and perform mail merges. \r\n \r\nChristina will show you how to create consistent documentation with document templates and font options. She\u2019ll demonstrate how to create and manage styles as well as how to use advanced find techniques and add cover pages. You\u2019ll learn how to create AutoText, manage Quick Parts, and use the features built into AutoMath and AutoFormat to type and format more efficiently. You\u2019ll also learn how to use graphic tools and drawing options. \r\n \r\nIf you\u2019re collaborating with others, you\u2019ll find it helpful to learn how to streamline information gathering with forms and how to protect documents when sharing or sending. You\u2019ll even learn how to transform a document into a Sway! \r\n\r\nEnjoy award winning HD content in the \u201cUniquely Engaging\u201dTM Bigger Brains Teacher-Learner style! Taught by top subject matter experts, Bigger Brains courses are professionally designed around key learning objectives, and include captions and transcripts in 29 languages, and downloadable handouts.",
                "learning_objectives_html": "<p><strong> You will be able to:</strong></p>\r\n<ul>\r\n    <li>Manage document templates</li>\r\n    <li>Customize a table of contents</li>\r\n    <li>Master font options and styles</li>\r\n    <li>Use advanced find techniques</li>\r\n    <li>Add and customize watermarks</li>\r\n    <li>Manage Quick Parts</li>\r\n    <li>Work with custom dictionaries</li>\r\n    <li>Use the features built into AutoMath and AutoFormat</li>\r\n    <li>Customize footnotes, headers, footers, and columns</li>\r\n    <li>Add and link text boxes</li>\r\n    <li>Insert and manage fields</li>\r\n    <li>Protect and add signatures to documents</li>\r\n    <li>Merge documents and perform a mail merge</li>\r\n    <li>Use graphic tools and drawing options</li>\r\n    <li>Create, modify, and use forms</li>\r\n    <li>Transform a document into a Sway</li>\r\n</ul>",
                "course_outline_html": "Increase your knowledge and skills to expertly utilize the features of the world&rsquo;s most powerful document creation software.",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "8BECCD1B-AAA2-EF11-9995-005056A725AD",
                        "course_category_name": "Bigger Brains - Business Technology Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5FD53AE4-2326-E711-9EDE-005056B14F90",
                        "course_category_name": "Workplace Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6E6072D9-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Business Technology Bundle \u2013 Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C504515B-A376-EF11-9990-005056A70840",
                        "course_category_name": "Bigger Brains",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F5470F5D-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9E064EE7-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle \u2013 Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "46FE47C6-0C11-E811-BA0F-005056B11FFF",
                        "course_category_name": "Module",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "69EA49AC-A9A2-EF11-9995-005056A725AD",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AC120620-CD8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Fire Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BC68CAB2-AD48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Business Technology Bundle - Courses",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "PMI",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This course is approved by the Project Management Institute (PMI) and qualifies for Professional Development Units (PDUs).",
                    "credit_display_name": "PMI",
                    "credit_units": 2.0,
                    "credit_unit_display_name": "PDU"
                },
                "sub_courses": []
            },
            {
                "course_id": "B979E53F-585A-F111-99B3-005056A740BF",
                "course_version": 1,
                "name": "Mastering Outlook 365 - Basics (2025)",
                "course_type": 1,
                "author_information": "Bigger Brains",
                "description": "There\u2019s more to Outlook than just email. Learn how to use the many features of Microsoft\u2019s powerful productivity tool. \r\n\r\nFew things have a greater impact on your productivity than how you use Outlook. Too many people waste time on unnecessary tasks when they could be taking advantage of the many features embedded in Outlook.\u00a0\u00a0\r\n\r\nIn this course, Microsoft expert Chip Reaves will show you how to customize Outlook to fit how you work, as well as shortcuts to streamline how you create and manage messages. You\u2019ll also learn tricks to help you schedule meetings and track responses, as well as how to use your contacts effectively. Brush up on your Outlook skills, so you can become more efficient using many of the tools Outlook has to offer.",
                "learning_objectives_html": "<ul>\r\n    <li>Navigate and customize the Ribbon and QAT</li>\r\n    <li>Customize a view</li>\r\n    <li>Add and format message text</li>\r\n    <li>Set delivery options</li>\r\n    <li>Attach a file to an email or other Outlook items using multiple methods</li>\r\n    <li>Handle incoming attachments</li>\r\n    <li>Sort, filter, and search for messages</li>\r\n    <li>Create, modify, and use folders</li>\r\n    <li>Add new appointments and meetings and modify settings</li>\r\n    <li>Use the Scheduling Assistant</li>\r\n    <li>Create and edit recurring meetings</li>\r\n    <li>Add, edit, and use contacts</li>\r\n    <li>Create and use a new contact group<br />\r\n    <br />\r\n    </li>\r\n</ul>",
                "course_outline_html": "There&rsquo;s more to Outlook than just email. Learn how to use the many features of Microsoft&rsquo;s powerful productivity tool.",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "9E064EE7-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle \u2013 Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C504515B-A376-EF11-9990-005056A70840",
                        "course_category_name": "Bigger Brains",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6E6072D9-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Business Technology Bundle \u2013 Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F5470F5D-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5FD53AE4-2326-E711-9EDE-005056B14F90",
                        "course_category_name": "Workplace Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8BECCD1B-AAA2-EF11-9995-005056A725AD",
                        "course_category_name": "Bigger Brains - Business Technology Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "46FE47C6-0C11-E811-BA0F-005056B11FFF",
                        "course_category_name": "Module",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "69EA49AC-A9A2-EF11-9995-005056A725AD",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AC120620-CD8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Fire Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BC68CAB2-AD48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Business Technology Bundle - Courses",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "PMI",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This course is approved by the Project Management Institute (PMI) and qualifies for Professional Development Units (PDUs).",
                    "credit_display_name": "PMI",
                    "credit_units": 1.5,
                    "credit_unit_display_name": "PDU"
                },
                "sub_courses": []
            },
            {
                "course_id": "E107E9BA-5B5A-F111-99B3-005056A740BF",
                "course_version": 1,
                "name": "Mastering Outlook 365 - Advanced (2025)",
                "course_type": 1,
                "author_information": "Bigger Brains",
                "description": "Microsoft Outlook 365 enables you to efficiently manage email, calendars, tasks, and contacts. Learn how to optimize the features of this powerful tool to skillfully organize messages and improve communication and scheduling. \r\n\r\nHaving access to powerful tools is different from knowing how to use them with proficiency. Many people currently using Outlook are not taking advantage of the software\u2019s advanced features to customize their messaging and improve communication.\u00a0\u00a0\r\n\r\nIn this course, Microsoft expert Vicki Drewa will show you how to use many of the organization features built into Outlook to set up accounts, manage data files, and manage your inbox. You will be able to customize your Outlook environment by adding commands to the Quick Access Toolbar and placing groups and commands on a new tab.\u00a0\u00a0\r\n\r\nWondering how to best use Outlook to communicate effectively? You\u2019ll learn how to customize your emails through formatting rules, stationery, and themes. You\u2019ll be able to share information by inserting tables, calendars, and images into your messages and collect feedback by using polls and voting buttons. Additionally, scheduling will be easier as you\u2019ll be able to share calendars, delegate permissions and create calendar groups. And more!\u00a0\r\n\r\nImprove your Outlook expertise by becoming more proficient in using many of the tools and features Outlook has to offer.",
                "learning_objectives_html": "<ul>\r\n    <li>Distinguish between POP, IMAP, and Exchange accounts</li>\r\n    <li>Create contact groups and recurring meetings</li>\r\n    <li>Add and remove commands from the Quick Access Toolbar and create a new tab with groups and commands</li>\r\n    <li>Create, manage, and share data files</li>\r\n    <li>Insert tables, calendars, and images into messages</li>\r\n    <li>Customize emails by setting conditional formatting rules and using stationery and themes</li>\r\n    <li>Utilize Quick Parts, AutoText, and drawing features</li>\r\n    <li>Leverage voting buttons and polls through email</li>\r\n    <li>Create, edit, and delete Quick Steps, rules, and alerts</li>\r\n    <li>Manage your inbox using sort, filter, and junk mail options</li>\r\n    <li>Streamline scheduling by sharing calendars, delegating permissions, and creating calendar groups</li>\r\n</ul>",
                "course_outline_html": "There is more to Outlook than just email. Learn how to use the advanced features of Microsoft&rsquo;s powerful productivity tool.",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "BC68CAB2-AD48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Business Technology Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AC120620-CD8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Fire Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "69EA49AC-A9A2-EF11-9995-005056A725AD",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "46FE47C6-0C11-E811-BA0F-005056B11FFF",
                        "course_category_name": "Module",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5FD53AE4-2326-E711-9EDE-005056B14F90",
                        "course_category_name": "Workplace Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8BECCD1B-AAA2-EF11-9995-005056A725AD",
                        "course_category_name": "Bigger Brains - Business Technology Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F5470F5D-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C504515B-A376-EF11-9990-005056A70840",
                        "course_category_name": "Bigger Brains",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6E6072D9-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Business Technology Bundle \u2013 Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9E064EE7-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle \u2013 Courses",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "PMI",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This course is approved by the Project Management Institute (PMI) and qualifies for Professional Development Units (PDUs).",
                    "credit_display_name": "PMI",
                    "credit_units": 1.25,
                    "credit_unit_display_name": "PDU"
                },
                "sub_courses": []
            },
            {
                "course_id": "329D347F-685A-F111-99B3-005056A740BF",
                "course_version": 1,
                "name": "Mastering Outlook 365 - Expert (2025)",
                "course_type": 1,
                "author_information": "Bigger Brains",
                "description": "Learn how to optimize the features of Outlook 365 to skillfully organize messages and improve communication and scheduling. \r\n\r\nIn this course, Microsoft expert Vicky Drewa will show you how to use many of the advanced features built into Outlook to help you work with multiple users and accounts. These include setting up profiles, managing multiple accounts, delegating permission levels, and viewing shared folders. By reviewing the many options and settings available for email and calendars, you will be able to customize your Outlook environment so it works best for you. You\u2019ll also learn how to set preferences for working offline or on slow connections.\u00a0\r\n\r\nAre you looking for some time savers? Learning how to use add-ins, templates, and advanced search techniques will help you work more efficiently and effectively. Customizing flags and Quick Actions options will help you keep track of tasks based on your emails.\u00a0\r\n\r\nWondering how to manage all your emails? Vicki will show you some great tips on cleaning up your Inbox using archiving and the Clean Up feature, as well as how to customize policies and retention settings for individual emails and folders. You also learn how to customize business cards and share contacts multiple ways.\u00a0\r\n\r\nImprove your Outlook expertise by becoming more proficient in using many of the tools and features Outlook has to offer.",
                "learning_objectives_html": "<ul>\r\n    <li>Change options for language settings, read receipts, editor settings, and signatures</li>\r\n    <li>Archive a message</li>\r\n    <li>Customize Outlook panes and views</li>\r\n    <li>Work offline and set preferences for downloading headers and items</li>\r\n    <li>Manage RSS feeds</li>\r\n    <li>Create and use a new profile</li>\r\n    <li>Add and manage add-ins such as Viva Insights and DocuSign</li>\r\n    <li>Add Loop Components to a message</li>\r\n    <li>Create and save an email template in OFT format</li>\r\n    <li>Delegate folder access and set delegate permission levels</li>\r\n    <li>Use Advanced Find to search for words or set criteria</li>\r\n    <li>Create a search folder from default categories or a custom search folder</li>\r\n    <li>Use Clean Up Conversations and Clean Up Folder to delete redundant messages</li>\r\n    <li>Reduce mailbox size and attachment sizes</li>\r\n</ul>",
                "course_outline_html": "There is more to Outlook than just email. Learn how to use expert-level features of Microsoft&rsquo;s powerful productivity tool.",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "6E6072D9-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Business Technology Bundle \u2013 Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C504515B-A376-EF11-9990-005056A70840",
                        "course_category_name": "Bigger Brains",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9E064EE7-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle \u2013 Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F5470F5D-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8BECCD1B-AAA2-EF11-9995-005056A725AD",
                        "course_category_name": "Bigger Brains - Business Technology Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5FD53AE4-2326-E711-9EDE-005056B14F90",
                        "course_category_name": "Workplace Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "46FE47C6-0C11-E811-BA0F-005056B11FFF",
                        "course_category_name": "Module",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AC120620-CD8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Fire Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BC68CAB2-AD48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Business Technology Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "69EA49AC-A9A2-EF11-9995-005056A725AD",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle - Courses",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "PMI",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This course is approved by the Project Management Institute (PMI) and qualifies for Professional Development Units (PDUs).",
                    "credit_display_name": "PMI",
                    "credit_units": 1.0,
                    "credit_unit_display_name": "PDU"
                },
                "sub_courses": []
            },
            {
                "course_id": "47D0A203-448A-EF11-9992-005056A70B00",
                "course_version": 2,
                "name": "Mastering Excel 2021 - Beginner",
                "course_type": 1,
                "author_information": "Bigger Brains",
                "description": "Learn to use the world\u2019s most popular software tool for analyzing and reporting on data.\r\n\r\nWhen you master Excel, you have one of the most practical and valuable skillsets in modern business. You will learn to work wonders with your data\u2014from organizing lists to creating charts and interactive reports.Excel will help you answer critical business questions like ROI, budget allocations, expense tracking, and more. This course is your first step towards becoming an expert at using Excel.\r\n\r\nEnjoy award winning HD content in the \u201cUniquely Engaging\u201dTM Bigger Brains Teacher-Learner style! Taught by top subject matter experts, Bigger Brains courses are professionally designed around key learning objectives, and include captions and transcripts in 29 languages, and downloadable handouts.",
                "learning_objectives_html": "<p><strong>You will be able to:</strong></p>\r\n<ul>\r\n    <li>Navigate the interface including accessing commands and selecting and entering data</li>\r\n    <li>Create and save a new workbook</li>\r\n    <li>Perform calculations using formulas and functions</li>\r\n    <li>Format text cells and apply Conditional Formatting</li>\r\n    <li>Print workbooks</li>\r\n    <li>Add charts and graphics to your workbook</li>\r\n    <li>Sort and filter data in a list</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "5FD53AE4-2326-E711-9EDE-005056B14F90",
                        "course_category_name": "Workplace Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8BECCD1B-AAA2-EF11-9995-005056A725AD",
                        "course_category_name": "Bigger Brains - Business Technology Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F5470F5D-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9E064EE7-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle \u2013 Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6E6072D9-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Business Technology Bundle \u2013 Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C504515B-A376-EF11-9990-005056A70840",
                        "course_category_name": "Bigger Brains",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "46FE47C6-0C11-E811-BA0F-005056B11FFF",
                        "course_category_name": "Module",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BC68CAB2-AD48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Business Technology Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AC120620-CD8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Fire Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "69EA49AC-A9A2-EF11-9995-005056A725AD",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle - Courses",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "PMI",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This course is approved by the Project Management Institute (PMI) and qualifies for Professional Development Units (PDUs).",
                    "credit_display_name": "PMI",
                    "credit_units": 2.0,
                    "credit_unit_display_name": "PDU"
                },
                "sub_courses": []
            },
            {
                "course_id": "6554E284-448A-EF11-9992-005056A70B00",
                "course_version": 3,
                "name": "Mastering Excel 365 - Beginner (2025)",
                "course_type": 1,
                "author_information": "Bigger Brains",
                "description": "Learn how to use the world\u2019s most popular software tool for analyzing and reporting on data. \r\n\r\nWhen you master Excel, you have one of the most practical and valuable skillsets in modern business. You will learn to work wonders with your data\u2014from organizing lists to creating charts and interactive reports. Excel will help you answer critical business questions like ROI, budget allocations, expense tracking, and more. This course is your first step towards becoming an expert at using Excel.\r\n\r\nEnjoy award winning HD content in the \u201cUniquely Engaging\u201dTM Bigger Brains Teacher-Learner style! Taught by top subject matter experts, Bigger Brains courses are professionally designed around key learning objectives, and include captions and transcripts in 29 languages, and downloadable handouts.",
                "learning_objectives_html": "<p><strong>You will be able to:</strong></p>\r\n<ul>\r\n    <li>Navigate the interface including accessing commands and selecting and entering data</li>\r\n    <li>Create and save a new workbook</li>\r\n    <li>Perform calculations using formulas and functions</li>\r\n    <li>Format text cells and apply Conditional Formatting</li>\r\n    <li>Print workbooks</li>\r\n    <li>Add charts and graphics to your workbook</li>\r\n    <li>Sort and filter data in a list</li>\r\n</ul>",
                "course_outline_html": "Bigger Brains, Artificial Intelligence, Mastering Excel 365 - Beginner (2025)",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "5FD53AE4-2326-E711-9EDE-005056B14F90",
                        "course_category_name": "Workplace Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8BECCD1B-AAA2-EF11-9995-005056A725AD",
                        "course_category_name": "Bigger Brains - Business Technology Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F5470F5D-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9E064EE7-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle \u2013 Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6E6072D9-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Business Technology Bundle \u2013 Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C504515B-A376-EF11-9990-005056A70840",
                        "course_category_name": "Bigger Brains",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "46FE47C6-0C11-E811-BA0F-005056B11FFF",
                        "course_category_name": "Module",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AC120620-CD8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Fire Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "69EA49AC-A9A2-EF11-9995-005056A725AD",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BC68CAB2-AD48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Business Technology Bundle - Courses",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "PMI",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This course is approved by the Project Management Institute (PMI) and qualifies for Professional Development Units (PDUs).",
                    "credit_display_name": "PMI",
                    "credit_units": 2.0,
                    "credit_unit_display_name": "PDU"
                },
                "sub_courses": []
            },
            {
                "course_id": "23F8A229-488A-EF11-9992-005056A70B00",
                "course_version": 2,
                "name": "Mastering PowerPoint 2021 - Intermediate",
                "course_type": 1,
                "author_information": "Bigger Brains",
                "description": "Learn how to create visually interesting presentations that will cause people to sit up and pay attention.\u00a0\r\n\r\nMicrosoft PowerPoint is the most popular tool for presentations in the workplace, so using it effectively is a crucial skill for any business professional. In this course, you\u2019ll learn design principles and how to customize themes to help you capture and retain the attention of your audience. Our PowerPoint expert Kathy Snizaski will also show you how to make your slides more readable using formatting tools and customizing tabs and spacing. Do you need to illustrate data? You can create a chart right in PowerPoint or import data from Excel and graph it on a slide.\u00a0\u00a0\r\n\r\nPictures and other graphics are always important in a presentation, and you\u2019ll learn how to customize and animate many types of graphics, including SmartArt, text boxes, and shapes. And if you need to collaborate, you\u2019ll learn how to use comments effectively to exchange ideas about the presentation. You\u2019ll be amazed at all the tools available to create and customize interesting and informative presentations.\u00a0\r\n\r\nEnjoy award winning HD content in the \u201cUniquely Engaging\u201dTM Bigger Brains Teacher-Learner style! Taught by top subject matter experts, Bigger Brains courses are professionally designed around key learning objectives, and include captions and transcripts in 29 languages, and downloadable handouts.",
                "learning_objectives_html": "<p><strong>You will be able to:</strong></p>\r\n<ul>\r\n    <li>Modify slide design and apply themes</li>\r\n    <li>Use editing tools</li>\r\n    <li>Add and modify tabs, line spacing, and paragraph spacing</li>\r\n    <li>Insert and modify charts</li>\r\n    <li>Customize SmartArt, pictures, shapes, and text boxes</li>\r\n    <li>Create a photo album</li>\r\n    <li>Apply and customize animation and transitions</li>\r\n    <li>Use comments</li>\r\n    <li>Print a presentation and create handouts</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "8BECCD1B-AAA2-EF11-9995-005056A725AD",
                        "course_category_name": "Bigger Brains - Business Technology Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5FD53AE4-2326-E711-9EDE-005056B14F90",
                        "course_category_name": "Workplace Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F5470F5D-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C504515B-A376-EF11-9990-005056A70840",
                        "course_category_name": "Bigger Brains",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9E064EE7-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle \u2013 Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6E6072D9-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Business Technology Bundle \u2013 Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "46FE47C6-0C11-E811-BA0F-005056B11FFF",
                        "course_category_name": "Module",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BC68CAB2-AD48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Business Technology Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "69EA49AC-A9A2-EF11-9995-005056A725AD",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AC120620-CD8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Fire Safety",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "PMI",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This course is approved by the Project Management Institute (PMI) and qualifies for Professional Development Units (PDUs).",
                    "credit_display_name": "PMI",
                    "credit_units": 2.0,
                    "credit_unit_display_name": "PDU"
                },
                "sub_courses": []
            },
            {
                "course_id": "5532D055-4A8A-EF11-9992-005056A70B00",
                "course_version": 3,
                "name": "Mastering Word 365 - Basics (2025)",
                "course_type": 1,
                "author_information": "Bigger Brains",
                "description": "Learn the basics of the world\u2019s most powerful document creation software .\r\n\r\nWord is more than a word processor. It has the potential to make you more productive and make your job easier! While used by millions of people daily, there are few who know how to maximize Word\u2019s functions and features. In this course taught by Microsoft trainer Christina Tankersley, we\u2019ll show you everything you need to know to work efficiently and create polished documents.\u00a0\r\n\r\nEnjoy award winning HD content in the \u201cUniquely Engaging\u201dTM Bigger Brains Teacher-Learner style! Taught by top subject matter experts, Bigger Brains courses are professionally designed around key learning objectives, and include captions and transcripts in 29 languages, and downloadable handouts.",
                "learning_objectives_html": "<p><strong>You will be able to:</strong></p>\r\n<ul>\r\n    <li>Navigate within documents using shortcuts</li>\r\n    <li>Create, save, and print documents</li>\r\n    <li>Select, copy, and move text</li>\r\n    <li>Use Find, Replace, and Go To</li>\r\n    <li>Format text</li>\r\n    <li>Apply Styles</li>\r\n    <li>Use the Format Painter</li>\r\n    <li>Format paragraphs</li>\r\n    <li>Work with tables</li>\r\n    <li>Sort lists</li>\r\n    <li>Use the Editor, the Thesaurus, and the Read Aloud feature</li>\r\n    <li>Insert and modify graphics</li>\r\n</ul>",
                "course_outline_html": "Learn the basics of the world&rsquo;s most powerful document creation software",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "8BECCD1B-AAA2-EF11-9995-005056A725AD",
                        "course_category_name": "Bigger Brains - Business Technology Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5FD53AE4-2326-E711-9EDE-005056B14F90",
                        "course_category_name": "Workplace Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9E064EE7-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle \u2013 Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C504515B-A376-EF11-9990-005056A70840",
                        "course_category_name": "Bigger Brains",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6E6072D9-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Business Technology Bundle \u2013 Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F5470F5D-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "46FE47C6-0C11-E811-BA0F-005056B11FFF",
                        "course_category_name": "Module",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "69EA49AC-A9A2-EF11-9995-005056A725AD",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BC68CAB2-AD48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Business Technology Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AC120620-CD8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Fire Safety",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "PMI",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This course is approved by the Project Management Institute (PMI) and qualifies for Professional Development Units (PDUs).",
                    "credit_display_name": "PMI",
                    "credit_units": 1.25,
                    "credit_unit_display_name": "PDU"
                },
                "sub_courses": []
            },
            {
                "course_id": "7EEB0522-C45D-F111-99B6-005056A77B46",
                "course_version": 1,
                "name": "Mastering Outlook 365 - Beginner (2025)",
                "course_type": 1,
                "author_information": "Bigger Brains",
                "description": "There\u2019s more to Outlook than just email. Learn how to use the many features of Microsoft\u2019s powerful productivity tool. \r\n\r\nFew things have a greater impact on your productivity than how you use Outlook. Too many people waste time on unnecessary tasks when they could be taking advantage of the many features embedded in Outlook. This course will help you brush up on your Outlook skills, so you can become more productive while using the basic elements of Outlook.",
                "learning_objectives_html": "<ul>\r\n    <li>Navigate the Outlook interface</li>\r\n    <li>Turn the Focused Inbox on and off</li>\r\n    <li>Access Help options including searching for articles and locating important features</li>\r\n    <li>Send new emails and add basic formatting</li>\r\n    <li>Distinguish between the To, CC, and BCC fields</li>\r\n    <li>Distinguish between Reply, Reply All, and Forward</li>\r\n    <li>Locate draft messages, sent emails, and deleted emails</li>\r\n    <li>Navigate and customize the calendar</li>\r\n    <li>Add appointments to the calendar</li>\r\n    <li>View and create contacts</li>\r\n    <li>View and create tasks<br />\r\n    <br />\r\n    </li>\r\n</ul>",
                "course_outline_html": "N/A",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "9E064EE7-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle \u2013 Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C504515B-A376-EF11-9990-005056A70840",
                        "course_category_name": "Bigger Brains",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6E6072D9-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Business Technology Bundle \u2013 Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F5470F5D-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8BECCD1B-AAA2-EF11-9995-005056A725AD",
                        "course_category_name": "Bigger Brains - Business Technology Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5FD53AE4-2326-E711-9EDE-005056B14F90",
                        "course_category_name": "Workplace Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "69EA49AC-A9A2-EF11-9995-005056A725AD",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BC68CAB2-AD48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Business Technology Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AC120620-CD8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Fire Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "46FE47C6-0C11-E811-BA0F-005056B11FFF",
                        "course_category_name": "Module",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "PMI",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This course is approved by the Project Management Institute (PMI) and qualifies for Professional Development Units (PDUs).",
                    "credit_display_name": "PMI",
                    "credit_units": 0.5,
                    "credit_unit_display_name": "PDU"
                },
                "sub_courses": []
            },
            {
                "course_id": "C3DB0643-C55D-F111-99B6-005056A77B46",
                "course_version": 1,
                "name": "Mastering PowerPoint 365 - Basics (2025)",
                "course_type": 1,
                "author_information": "Bigger Brains",
                "description": "Learn how to create visually interesting presentations that will cause people to sit up and pay attention. \r\n\r\nMicrosoft PowerPoint is the most popular tool for presentations in the workplace, so using it effectively is a crucial skill for any business professional. In this course you\u2019ll learn to modify your bulleted and numbered lists, add tables for readability, and add animation to keep viewers engaged. Whether you are using a template design, customizing your own text boxes, or adding dynamic pictures, our PowerPoint expert Kathy Snizaski will show you how to create and customize interesting presentations, and present them flawlessly.",
                "learning_objectives_html": "<ul>\r\n    <li>Create a new presentation from a template</li>\r\n    <li>Open and save existing presentations</li>\r\n    <li>Modify slide design</li>\r\n    <li>Format text, text boxes, and lists</li>\r\n    <li>Spell check the document</li>\r\n    <li>Insert and modify pictures and shapes</li>\r\n    <li>Insert and modify a table</li>\r\n    <li>Add transitions and animation</li>\r\n    <li>Present a slide show</li>\r\n</ul>",
                "course_outline_html": "N/A",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "46FE47C6-0C11-E811-BA0F-005056B11FFF",
                        "course_category_name": "Module",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AC120620-CD8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Fire Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "69EA49AC-A9A2-EF11-9995-005056A725AD",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BC68CAB2-AD48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Business Technology Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8BECCD1B-AAA2-EF11-9995-005056A725AD",
                        "course_category_name": "Bigger Brains - Business Technology Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5FD53AE4-2326-E711-9EDE-005056B14F90",
                        "course_category_name": "Workplace Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9E064EE7-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle \u2013 Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6E6072D9-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Business Technology Bundle \u2013 Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C504515B-A376-EF11-9990-005056A70840",
                        "course_category_name": "Bigger Brains",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F5470F5D-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle - Courses",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "PMI",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This course is approved by the Project Management Institute (PMI) and qualifies for Professional Development Units (PDUs).",
                    "credit_display_name": "PMI",
                    "credit_units": 1.0,
                    "credit_unit_display_name": "PDU"
                },
                "sub_courses": []
            },
            {
                "course_id": "E7C761D8-785D-F111-99B6-005056A77B46",
                "course_version": 1,
                "name": "Mastering Excel 365 - Expert (2025)",
                "course_type": 1,
                "author_information": "Bigger Brains",
                "description": "Learn to enhance both communication and data analysis by expertly utilizing the advanced features of Excel 365.  \r\n\r\nBeing able to use Microsoft Excel skillfully is crucial for all business professionals who use, analyze, and apply data. Since Excel is the most popular data analysis tool in the workplace, increasing your ability to utilize its advanced features is vital for professional development and success. \r\n\r\nExcel expert Kathy Jones will show you how to share workbooks, create digital signatures, and restore a previous version of your workbook.  She will demonstrate how to utilize functions to find data, calculate dates, and determine rates and payments. You\u2019ll also learn how to streamline complex functions with LAMBDA and LET. In addition, you\u2019ll learn how to summarize data with PivotTables and how to create and modify PivotCharts.  \r\n\r\nBecause the visual display of data greatly enhances communication and understanding, Kathy will demonstrate how to create and modify waterfall, treemap, and funnel charts to illustrate your information in multiple ways. You\u2019ll learn how to use data map charts and 3-D maps to compare and analyze data. Kathy will also show you how to create a forecast timeline to look at trends in your data.  \r\n\r\nFinally, you will learn how to record, run, and edit macros so that you can automate repetitive tasks and save valuable time when formatting your worksheets!",
                "learning_objectives_html": "<p>You will be able to:</p>\r\n<ul>\r\n    <li>Share a workbook with other users</li>\r\n    <li>View and restore previous workbook versions using Version History</li>\r\n    <li>Insert and sign a digital signature line in a workbook</li>\r\n    <li>Get and transform external data</li>\r\n    <li>Compare and analyze data using data map charts and 3D maps</li>\r\n    <li>Create and modify waterfall, treemap, and funnel charts</li>\r\n    <li>Format and change the data source for a PivotTable</li>\r\n    <li>Create and modify PivotCharts</li>\r\n    <li>Create and manage internal and external links in your workbooks</li>\r\n    <li>Use functions to find data and calculate dates</li>\r\n    <li>Streamline complex functions with LAMBDA and LET</li>\r\n    <li>Create a forecast timeline</li>\r\n    <li>Using Add-ins such as Solver, the Data Analysis ToolPack, and Visio</li>\r\n    <li>Record, run, and edit macros</li>\r\n</ul>",
                "course_outline_html": "N/A",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "46FE47C6-0C11-E811-BA0F-005056B11FFF",
                        "course_category_name": "Module",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BC68CAB2-AD48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Business Technology Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AC120620-CD8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Fire Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "69EA49AC-A9A2-EF11-9995-005056A725AD",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8BECCD1B-AAA2-EF11-9995-005056A725AD",
                        "course_category_name": "Bigger Brains - Business Technology Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5FD53AE4-2326-E711-9EDE-005056B14F90",
                        "course_category_name": "Workplace Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6E6072D9-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Business Technology Bundle \u2013 Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9E064EE7-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle \u2013 Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F5470F5D-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C504515B-A376-EF11-9990-005056A70840",
                        "course_category_name": "Bigger Brains",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "PMI",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This course is approved by the Project Management Institute (PMI) and qualifies for Professional Development Units (PDUs).",
                    "credit_display_name": "PMI",
                    "credit_units": 3.5,
                    "credit_unit_display_name": "PDU"
                },
                "sub_courses": []
            },
            {
                "course_id": "BAEEB51B-085B-F111-99B6-005056A77B46",
                "course_version": 1,
                "name": "Mastering Outlook 365 - Intermediate (2025)",
                "course_type": 1,
                "author_information": "Bigger Brains",
                "description": "There\u2019s more to Outlook than just email. Learn how to use the many features of Microsoft\u2019s powerful productivity tool.\u00a0\r\n\r\nFew things have greater impact on your productivity than how you use Outlook. Too many people waste time on unnecessary tasks when they could be taking advantage of the many features embedded in Outlook.\u00a0\u00a0\r\n\r\nIn this course, Microsoft expert Kathy Jones will show you how to use many of the features built into Outlook to create professional outgoing messages, such as the accessibility checker and the Editor, as well as message options, signatures, and automatic replies. You\u2019ll also learn tools to manage incoming messages, such as tracking, categories and flags.\u00a0\u00a0\r\n\r\nStruggling with whether to use Teams or Outlook to schedule meetings? You\u2019ll learn the tricks of using Outlook to manage your Teams meetings. And make sure you customize your calendar to show exactly what you need to see. You\u2019ll also learn collaboration tools such as shared calendars and shared tasks.\u00a0\u00a0\r\n\r\nBrush up on your Outlook skills, so you can become more efficient using many of the tools Outlook has to offer.",
                "learning_objectives_html": "<ul>\r\n    <li>Attach items and documents</li>\r\n    <li>Check spelling and grammar in a message</li>\r\n    <li>Manage Editor options</li>\r\n    <li>Check accessibility</li>\r\n    <li>Modify message options</li>\r\n    <li>Create and add signatures to email</li>\r\n    <li>Customize and apply categories</li>\r\n    <li>Track sent messages</li>\r\n    <li>Manage flags and flagged messages</li>\r\n    <li>Set up and modify an automatic reply</li>\r\n    <li>Add new and shared calendars</li>\r\n    <li>Change calendar settings and defaults</li>\r\n    <li>Create and manage a Teams meeting from Outlook</li>\r\n    <li>Create and modify new tasks</li>\r\n    <li>Work with recurring tasks</li>\r\n    <li>Create and modify notes</li>\r\n    <li>Assign and track shared tasks<br />\r\n    <br />\r\n    </li>\r\n</ul>",
                "course_outline_html": "There&rsquo;s more to Outlook than just email. Learn how to use the many features of Microsoft&rsquo;s powerful productivity tool.",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "5FD53AE4-2326-E711-9EDE-005056B14F90",
                        "course_category_name": "Workplace Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8BECCD1B-AAA2-EF11-9995-005056A725AD",
                        "course_category_name": "Bigger Brains - Business Technology Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9E064EE7-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle \u2013 Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F5470F5D-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6E6072D9-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Business Technology Bundle \u2013 Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C504515B-A376-EF11-9990-005056A70840",
                        "course_category_name": "Bigger Brains",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "46FE47C6-0C11-E811-BA0F-005056B11FFF",
                        "course_category_name": "Module",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BC68CAB2-AD48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Business Technology Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AC120620-CD8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Fire Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "69EA49AC-A9A2-EF11-9995-005056A725AD",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle - Courses",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "PMI",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This course is approved by the Project Management Institute (PMI) and qualifies for Professional Development Units (PDUs).",
                    "credit_display_name": "PMI",
                    "credit_units": 1.5,
                    "credit_unit_display_name": "PDU"
                },
                "sub_courses": []
            },
            {
                "course_id": "A73D9DED-115B-F111-99B6-005056A77B46",
                "course_version": 1,
                "name": "Mastering PowerPoint 365 - Expert (2025)",
                "course_type": 1,
                "author_information": "Bigger Brains",
                "description": "Learn how to create visually interesting presentations that will cause people to sit up and pay attention. \r\n\r\nMicrosoft PowerPoint is the most popular tool for presentations in the workplace, so using it effectively is a crucial skill for any business professional. In this course, our PowerPoint teacher Kathy Snizaski will show you how to use PowerPoint\u2019s expert level options and tools to create powerful and dynamic presentations.\u00a0\u00a0\r\n\r\nMany of the tools in PowerPoint are designed to help you be a better presenter. Kathy will show you how to apply advanced animation, action buttons, and transitions to keep your audience interested. Did you know PowerPoint comes with a coach? You\u2019ll learn how to rehearse your presentations to fine-tune the timing, and also how to take advantage of your built-in coach. You\u2019ll also learn how to incorporate add-ins and manage video, along with other tools to customize and share your presentation.",
                "learning_objectives_html": "<ul>\r\n    <li>Merge and compare presentations</li>\r\n    <li>Use PowerPoint add-ins</li>\r\n    <li>Customize font sets</li>\r\n    <li>Add macros and ActiveX controls</li>\r\n    <li>Use and customize multiple slide masters</li>\r\n    <li>Edit pictures, WordArt, icons, and equations</li>\r\n    <li>Apply advanced animation, transitions, and action buttons</li>\r\n    <li>Manage video</li>\r\n    <li>Create custom slide shows</li>\r\n    <li>Maximize presentation skills with presenter view and rehearsal options</li>\r\n    <li>Add subtitles and cameos</li>\r\n    <li>Review accessibility</li>\r\n    <li>Record, share, and publish your presentation in multiple formats</li>\r\n</ul>",
                "course_outline_html": "Learn how to create visually interesting presentations that will cause people to sit up and pay attention.",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "8BECCD1B-AAA2-EF11-9995-005056A725AD",
                        "course_category_name": "Bigger Brains - Business Technology Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5FD53AE4-2326-E711-9EDE-005056B14F90",
                        "course_category_name": "Workplace Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C504515B-A376-EF11-9990-005056A70840",
                        "course_category_name": "Bigger Brains",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6E6072D9-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Business Technology Bundle \u2013 Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F5470F5D-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9E064EE7-AE48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle \u2013 Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "46FE47C6-0C11-E811-BA0F-005056B11FFF",
                        "course_category_name": "Module",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AC120620-CD8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Fire Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "69EA49AC-A9A2-EF11-9995-005056A725AD",
                        "course_category_name": "Bigger Brains - Microsoft Essentials Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BC68CAB2-AD48-F111-99AE-005056A76043",
                        "course_category_name": "Bigger Brains - Business Technology Bundle - Courses",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "PMI",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This course is approved by the Project Management Institute (PMI) and qualifies for Professional Development Units (PDUs).",
                    "credit_display_name": "PMI",
                    "credit_units": 1.5,
                    "credit_unit_display_name": "PDU"
                },
                "sub_courses": []
            }
        ]
    }
];